import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { Button } from '@mui/material';
import { isNil, set } from 'lodash';
import { configuration, user } from 'apis';
import { useQuery } from 'react-query';
import { useRef, useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useSnackbar } from 'notistack';
import SimpleAccordion from 'ui-component/accordion/SimpleAccordion';
import Typography from '@mui/material/Typography';
import * as wjGrid from '@grapecity/wijmo.grid';

const ChecklistScreen = () => {
    const checklistTables = useRef();
    const { enqueueSnackbar } = useSnackbar();

    const seasonGridRef = useRef();
    const seasonBeforeSaveRef = useRef([]);
    const [seasonErrors, setSeasonErrors] = useState({});
    const [seasonList, setSeasonList] = useState([]);
    const [seasonBeforeSave, setSeasonBeforeSave] = useState([]);
    const [originalSeason, setOriginalSeason] = useState({});
    const [seasonChanges, setSeasonChanges] = useState({});
    const [isSeasonChanged, setIsSeasonChanged] = useState(false);
    const [seasonModalItem, setSeasonModalItem] = useState({});
    const [isSeasonModalOpen, setIsSeasonModalOpen] = useState(false);

    const applicationTypeGridRef = useRef();
    const hasCapturedApplicationTypeSnapshot = useRef(false);
    const [applicationTypeErrors, setApplicationTypeErrors] = useState({});
    const [applicationTypeList, setApplicationTypeList] = useState([]);
    const [originalApplicationType, setOriginalApplicationType] = useState({});
    const [applicationTypeChanges, setApplicationTypeChanges] = useState({});
    const [isApplicationTypeChanged, setIsApplicationTypeChanged] = useState(false);
    const [applicationTypeListBeforeEdit, setApplicationTypeListBeforeEdit] = useState([]);
    const [modalItem, setModalItem] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const eventsGridRef = useRef();
    const [eventsChanges, setEventsChanges] = useState({});
    const [originalEvents, setOriginalEvents] = useState({});
    const [eventList, setEventList] = useState([]);
    const [isEventChanged, setIsEventChanged] = useState(false);
    const [isEventModalOpen, setIsEventModalOpen] = useState(false);
    const [eventModalItem, setEventModalItem] = useState({});
    const [lastCommittedEvents, setLastCommittedEvents] = useState([]);
    const [eventListBeforeEdit, setEventListBeforeEdit] = useState([]);
    const [eventErrors, setEventErrors] = useState({});

    const disciplineGridRef = useRef();
    const [disciplineChanges, setdisciplineChanges] = useState({});
    const [originalDiscipline, setOriginaldiscipline] = useState({});
    const [disciplineList, setDisciplineList] = useState([]);
    const [isDisciplineChanged, setIsDisciplineChanged] = useState(false);
    const [isDisciplineModalOpen, setIsDisciplineModalOpen] = useState(false);
    const [disciplineModalItem, setDisciplineModalItem] = useState({});
    const [lastCommittedDiscipline, setLastCommittedDiscipline] = useState([]);
    const [eventDisciplineBeforeEdit, setDisciplineListBeforeEdit] = useState([]);
    const [disciplineErrors, setDisciplineErrors] = useState({});

    const [disciplineParents, setDisciplineParents] = useState({});

    const ageCategoryGridRef = useRef();
    const [ageCategoryChanges, setageCategoryChanges] = useState({});
    const [originalAgeCategory, setOriginalIdAgeCategory] = useState({});
    const [ageCategoryList, setageCategoryList] = useState([]);
    const [isAgeCategoryChanged, setIsAgeCategoryChanged] = useState(false);
    const [isAgeCategoryModalOpen, setIsAgeCategoryModalOpen] = useState(false);
    const [AgeCategoryModalItem, setAgeCategoryModalItem] = useState({});
    const [lastCommittedageCategory, setLastCommittedageCategory] = useState([]);
    const [eventAgeCategoryBeforeEdit, setAgeCategoryListBeforeEdit] = useState([]);
    const [ageCategoryErrors, setAgeCategoryErrors] = useState({});

    const divisionGridRef = useRef();
    const [divisionChanges, setdivisionChanges] = useState({});
    const [originalDivision, setOriginalIdDivision] = useState({});
    const [divisionList, setdivisionList] = useState([]);
    const [isDivisionChanged, setIsDivisionChanged] = useState(false);
    const [isDivisionModalOpen, setIsDivisionModalOpen] = useState(false);
    const [DivisionModalItem, setDivisionModalItem] = useState({});
    const [lastCommitteddivision, setLastCommitteddivision] = useState([]);
    const [eventDivisionBeforeEdit, setDivisionListBeforeEdit] = useState([]);
    const [divisionErrors, setDivisionErrors] = useState({});

    const competitionTypeGridRef = useRef();
    const [competitionTypeChanges, setcompetitionTypeChanges] = useState({});
    const [originalCompetitionType, setOriginalIdCompetitionType] = useState({});
    const [competitionTypeList, setcompetitionTypeList] = useState([]);
    const [isCompetitionTypeChanged, setIsCompetitionTypeChanged] = useState(false);
    const [isCompetitionTypeModalOpen, setIsCompetitionTypeModalOpen] = useState(false);
    const [CompetitionTypeModalItem, setCompetitionTypeModalItem] = useState({});
    const [lastCommittedcompetitionType, setLastCommittedcompetitionType] = useState([]);
    const [eventCompetitionTypeBeforeEdit, setCompetitionTypeListBeforeEdit] = useState([]);
    const [competitionTypeErrors, setCompetitionTypeErrors] = useState({});

    const eventCategoryGridRef = useRef();
    const [eventCategoryChanges, seteventCategoryChanges] = useState({});
    const [originalEventCategory, setOriginalIdEventCategory] = useState({});
    const [eventCategoryList, seteventCategoryList] = useState([]);
    const [isEventCategoryChanged, setIsEventCategoryChanged] = useState(false);
    const [isEventCategoryModalOpen, setIsEventCategoryModalOpen] = useState(false);
    const [EventCategoryModalItem, setEventCategoryModalItem] = useState({});
    const [lastCommittedeventCategory, setLastCommittedeventCategory] = useState([]);
    const [eventEventCategoryBeforeEdit, setEventCategoryListBeforeEdit] = useState([]);
    const [eventCategoryErrors, setEventCategoryErrors] = useState({});

    //For Event Categories Pagination
    const start = 0;
    const [limit, setLimit] = useState(50);

    //Paginated Event Categories List
    const [paginatedEventCategories, setPaginatedEventCategories] = useState([]);

    //Variable for checking if I reached the lenght of the EventCategorylist in paginatedLIst
    //so I can stop rendering the "Next 50 ..." button
    const [paginationEnded, setPaginationEnded] = useState(false);

    const applicationTypeProductAgesGridRef = useRef();
    const [applicationTypeProductAgesChanges, setApplicationTypeProductAgesChanges] = useState({});
    const [originalApplicationTypeProductAges, setOriginalApplicationTypeProductAges] = useState({});
    const [isApplicationTypeProductAgesChanged, setIsApplicationTypeProductAgesChanged] = useState(false);

    //Application Type Product Service
    const applicationTypeProductServicesGridRef = useRef();
    const [applicationTypeProductServicesList, setApplicationTypeProductServicesList] = useState([]);
    const [isApplicationTypeProductServicesChanged, setIsApplicationTypeProductServicesChanged] = useState(false);
    const [isAppTypeProductServicesModalOpen, setIsAppTypeProductServicesModalOpen] = useState(false);
    const [appTypeProductServicesModalItem, setAppTypeProductServicesModalItem] = useState({});
    const [applicationTypeProductServicesBeforeEdit, setApplicationTypeProductServicesBeforeEdit] = useState([]);
    const [originalApplicationTypeProductServices, setOriginalApplicationTypeProductServices] = useState({});
    const [applicationTypeProductServicesChanges, setApplicationTypeProductServicesChanges] = useState({});
    const [lastCommittedApplicationTypeProductServices, setLastCommittedApplicationTypeProductServices] = useState([]);
    const [appTypeProductServicesErrors, setAppTypeProductServicesErrors] = useState({});

    const [fileTypesList, setFileTypesList] = useState([]);
    const [isFileTypesChanged, setIsFileTypesChanged] = useState(false);
    const [fileTypesChanges, setFileTypesChanges] = useState({});
    const [originalFileTypes, setOriginalFileTypes] = useState({});
    const fileTypesGridRef = useRef();
    const [isFileTypeModalOpen, setIsFileTypeModalOpen] = useState(false);
    const [fileTypeModalItem, setFileTypeModalItem] = useState({});
    const [fileTypesBeforeEdit, setFileTypesBeforeEdit] = useState([]);
    const [hasCapturedFileTypesSnapshot, setHasCapturedFileTypesSnapshot] = useState(false);
    const [fileTypesErrors, setFileTypesErrors] = useState({});

    const optionalAnswersGridRef = useRef();
    const [optionalAnswersList, setOptionalAnswersList] = useState([]);
    const [originalOptionalAnswers, setOriginalOptionalAnswers] = useState({});
    const [optionalAnswerChanges, setOptionalAnswerChanges] = useState({});
    const [isOptionalAnswerChanged, setIsOptionalAnswerChanged] = useState(false);
    const [optionalAnswerModalItem, setOptionalAnswerModalItem] = useState(null);
    const [isOptionalAnswerModalOpen, setIsOptionalAnswerModalOpen] = useState(false);
    const [optionalAnswersBeforeEdit, setOptionalAnswersBeforeEdit] = useState([]);
    const [hasCapturedOptionalAnswerSnapshot, setHasCapturedOptionalAnswerSnapshot] = useState(false);
    const [optionalAnswerErrors, setOptionalAnswerErrors] = useState({});

    const questionsGridRef = useRef();
    const [questionList, setQuestionList] = useState([]);
    const [questionChanges, setQuestionChanges] = useState({});
    const [originalQuestions, setOriginalQuestions] = useState({});
    const [isQuestionChanged, setIsQuestionChanged] = useState(false);
    const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
    const [questionModalItem, setQuestionModalItem] = useState({});
    const [lastCommittedQuestions, setLastCommittedQuestions] = useState([]);
    const [questionListBeforeEdit, setQuestionListBeforeEdit] = useState([]);
    const [hasCapturedQuestionSnapshot, setHasCapturedQuestionSnapshot] = useState(false);
    const [questionErrors, setQuestionErrors] = useState({});

    const [questionTypes, setQuestionTypes] = useState([]);

    //Product Services
    const [productServicesList, setProductServicesList] = useState([]);
    const [isProductServicesChanged, setIsProductServicesChanged] = useState(false);
    const [productServicesModalItem, setProductServicesModalItem] = useState({});
    const [productServicesBeforeEdit, setProductServicesBeforeEdit] = useState([]);
    const [productServicesChanges, setProductServicesChanges] = useState({});
    const [isProductServicesModalOpen, setIsProductServicesModalOpen] = useState(false);
    const [productServicesErrors, setProductServicesErrors] = useState({});
    const [originalProductServices, setOriginalProductServices] = useState({});

    const productServicesGridRef = useRef();

    const [transactionTypesList, setTransactionTypesList] = useState([]);

    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const confirmResolveRef = useRef(null);

    const [disciplines, setDisciplines] = useState([]);

    const [ageCategories, setAgeCategories] = useState([]);

    const eventDataQuery = useQuery(['checklistScreenEvent'], async () => {
        const eventResult = await configuration.getLKEvents();
        return eventResult;
    });

    const disciplineDataQuery = useQuery(['checklistScreenDiscipline'], async () => {
        const disciplineResult = await configuration.getDisciplines();
        return disciplineResult;
    });

    const ageCategoryDataQuery = useQuery(['checklistScreenAgeCategory'], async () => {
        const ageCategoryResult = await configuration.getAgeCategories();
        return ageCategoryResult;
    });

    const divisionDataQuery = useQuery(['checklistScreenDivision'], async () => {
        const divisionResult = await configuration.getDivisions();
        return divisionResult;
    });

    const competitionTypeDataQuery = useQuery(['checklistScreenCompetitionType'], async () => {
        const competitionTypeResult = await configuration.getCompetitionTypes();
        return competitionTypeResult;
    });

    const eventCategoryDataQuery = useQuery(['checklistScreenEventCategory'], async () => {
        const eventCategoryResult = await configuration.getEventCategories();
        return eventCategoryResult;
    });

    const seasonDataQuery = useQuery(['checklistScreenSeason'], async () => {
        const seasonResult = await configuration.getLKSeason();
        return seasonResult;
    });

    const applicationTypeProductAgesDataQuery = useQuery(['checklistScreenApplicationTypeProductAges'], async () => {
        const applicationTypeProductAgesResult = await configuration.getApplicationTypeProductAges();
        return applicationTypeProductAgesResult;
    });

    const applicationTypeProductServicesDataQuery = useQuery(['checklistScreenApplicationTypeProductServices'], async () => {
        const applicationTypeProductServicesResult = await configuration.getApplicationTypeProductServices();
        return applicationTypeProductServicesResult;
    });

    const fileTypesDataQuery = useQuery(['checklistScreenFileTypes'], async () => {
        const result = await configuration.getFileTypes();
        return result;
    });

    const applicationTypeDataQuery = useQuery(['checklistScreenApplicationType'], async () => {
        const applicationTypeResult = await configuration.getApplicationType();
        return applicationTypeResult;
    });

    const optionalAnswerDataQuery = useQuery(['checklistScreenOptionalAnswers'], async () => {
        const res = await configuration.getOptionalAnswers();
        return res;
    });

    const questionDataQuery = useQuery(['checklistScreenQuestion'], async () => {
        const questionResult = await configuration.getQuestion();
        return questionResult;
    });

    const productServicesQuery = useQuery(['checklistScreenProductServices'], async () => {
        const result = await configuration.getProductServices();
        return result;
    });

    const defaultResultsFieldsMapping = JSON.stringify([
        { fldName: 'Str01', fldTitle: 'Επίδοση' },
        { fldName: 'Str02', fldTitle: 'Ποινές' },
        { fldName: 'Str03', fldTitle: 'Σύνολο' },
        { fldName: 'Str04', fldTitle: 'ΔΙΑΔΡΟΜΗ #1' },
        { fldName: 'Str05', fldTitle: 'ΔΙΑΔΡΟΜΗ #2' }
    ]);

    useEffect(() => {
        if (seasonDataQuery.status === 'success' && Array.isArray(seasonDataQuery.data)) {
            const enriched = seasonDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));

            const deepCopy = JSON.parse(JSON.stringify(enriched));

            setSeasonList(deepCopy);

            if (!seasonBeforeSaveRef.current.length) {
                seasonBeforeSaveRef.current = deepCopy;
            }
        }
    }, [seasonDataQuery.status, seasonDataQuery.data]);

    useEffect(() => {
        if (applicationTypeDataQuery.status === 'success' && Array.isArray(applicationTypeDataQuery.data)) {
            const enriched = applicationTypeDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setApplicationTypeList(enriched);
            setApplicationTypeListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [applicationTypeDataQuery.status, applicationTypeDataQuery.data]);

    useEffect(() => {
        if (eventDataQuery.status === 'success' && Array.isArray(eventDataQuery.data)) {
            const enriched = eventDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setEventList(enriched);
            setEventListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [eventDataQuery.status, eventDataQuery.data]);

    useEffect(() => {
        if (disciplineDataQuery.status === 'success' && Array.isArray(disciplineDataQuery.data)) {
            const enriched = disciplineDataQuery.data.map((item) => ({
                ...item,
                parentId: item.parentId ?? 'null',
                isNew: false,
                isDeleted: false
            }));
            setDisciplineList(enriched);

            let parents = enriched.filter((item) => {
                return item.parentId === 'null';
            });

            parents = [{ id: 999, name: 'null' }, ...parents];

            setDisciplineParents(parents);

            setDisciplineListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [disciplineDataQuery.status, disciplineDataQuery.data]);

    useEffect(() => {
        if (ageCategoryDataQuery.status === 'success' && Array.isArray(ageCategoryDataQuery.data)) {
            const enriched = ageCategoryDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setageCategoryList(enriched);

            setAgeCategoryListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [ageCategoryDataQuery.status, ageCategoryDataQuery.data]);

    useEffect(() => {
        if (divisionDataQuery.status === 'success' && Array.isArray(divisionDataQuery.data)) {
            const enriched = divisionDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setdivisionList(enriched);

            setDivisionListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [divisionDataQuery.status, divisionDataQuery.data]);

    useEffect(() => {
        if (competitionTypeDataQuery.status === 'success' && Array.isArray(competitionTypeDataQuery.data)) {
            const enriched = competitionTypeDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setcompetitionTypeList(enriched);

            setCompetitionTypeListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [competitionTypeDataQuery.status, competitionTypeDataQuery.data]);

    useEffect(() => {
        if (eventCategoryDataQuery.status === 'success' && Array.isArray(eventCategoryDataQuery.data)) {
            const enriched = eventCategoryDataQuery.data.map((item) => ({
                id: item.id,
                eventId: item.eventId,
                ageCategoryId: item.ageCategoryId,
                divisionId: item.divisionId ?? 'null',
                additionalDescr: item.additionalDescr ?? 'null',
                distanceFrom: item.distanceFrom ?? 'null',
                distanceTo: item.distanceTo ?? 'null',
                distanceDescr: item.distanceDescr ?? 'null',
                weightFrom: item.weightFrom ?? 'null',
                weightTo: item.weightTo ?? 'null',
                weightDescr: item.weightDescr ?? 'null',
                heightFrom: item.heightFrom ?? 'null',
                heightTo: item.heightTo ?? 'null',
                heightDescr: item.heightDescr ?? 'null',
                isOlympic: item.isOlympic ?? false,
                isNew: false,
                isDeleted: false
            }));
            seteventCategoryList(enriched);
            setPaginatedEventCategories(enriched.slice(start, limit));

            setEventCategoryListBeforeEdit(JSON.parse(JSON.stringify(enriched)));
        }
    }, [eventCategoryDataQuery.status, eventCategoryDataQuery.data]);

    useEffect(() => {
        if (
            applicationTypeProductServicesDataQuery.status === 'success' &&
            Array.isArray(applicationTypeProductServicesDataQuery.data) &&
            applicationTypeList.length > 0
        ) {
            const enriched = applicationTypeProductServicesDataQuery.data.map((item) => {
                const appType = applicationTypeList.find((a) => Number(a.id) === Number(item.applicationTypeId));
                const prodService = productServicesList.find((p) => Number(p.id) === Number(item.productServiceId));

                return {
                    ...item,
                    id: item.applicationTypeProductServicesId,
                    applicationTypeTitle: appType?.description || `App#${item.applicationTypeId}`,
                    productServiceTitle: prodService?.description || `PS#${item.productServiceId}`,
                    isNew: false,
                    isDeleted: false
                };
            });

            setApplicationTypeProductServicesList(enriched);
            setLastCommittedApplicationTypeProductServices(JSON.parse(JSON.stringify(enriched)));
        }
    }, [
        applicationTypeProductServicesDataQuery.status,
        applicationTypeProductServicesDataQuery.data,
        applicationTypeList,
        productServicesList
    ]);

    useEffect(() => {
        if (fileTypesDataQuery.status === 'success' && Array.isArray(fileTypesDataQuery.data)) {
            const enriched = fileTypesDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setFileTypesList(enriched);
        }
    }, [fileTypesDataQuery.status, fileTypesDataQuery.data]);

    useEffect(() => {
        if (optionalAnswerDataQuery.status === 'success' && Array.isArray(optionalAnswerDataQuery.data)) {
            const enriched = optionalAnswerDataQuery.data.map((item) => {
                const question = questionList.find((q) => q.id === item.questionId);
                return {
                    ...item,
                    isActive: item.isActive ?? true,
                    isDisabled: item.isDisabled ?? false,
                    questionTitle: question?.title ?? `Q#${item.questionId}`,
                    isNew: false,
                    isDeleted: false
                };
            });
            setOptionalAnswersList(enriched);
        }
    }, [optionalAnswerDataQuery.status, optionalAnswerDataQuery.data, questionList]);

    useEffect(() => {
        if (questionDataQuery.status === 'success' && Array.isArray(questionDataQuery.data)) {
            const enriched = questionDataQuery.data.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));
            setQuestionList(enriched);
        }
    }, [questionDataQuery.status, questionDataQuery.data]);

    useEffect(() => {
        const fetchQuestionTypes = async () => {
            try {
                const res = await configuration.getQuestionTypes();
                if (Array.isArray(res)) {
                    setQuestionTypes(res);
                }
            } catch (err) {
                console.error('Failed to load question types', err);
            }
        };

        fetchQuestionTypes();
    }, []);

    useEffect(() => {
        const fetchProductServices = async () => {
            try {
                const res = await configuration.getProductServices();
                setProductServicesList(res);
            } catch (err) {
                console.error('Failed to load product services:', err);
            }
        };

        fetchProductServices();
    }, []);

    useEffect(() => {
        const fetchTransactionTypes = async () => {
            try {
                const res = await configuration.getTransactionTypes();
                setTransactionTypesList(res);
            } catch (err) {
                console.error('Failed to fetch transaction types', err);
            }
        };

        fetchTransactionTypes();
    }, []);

    const confirmSave = () => {
        return new Promise((resolve) => {
            confirmResolveRef.current = resolve;
            setIsConfirmOpen(true);
        });
    };

    useEffect(() => {
        const fetchDisciplines = async () => {
            try {
                const res = await configuration.getDisciplines();
                if (Array.isArray(res)) {
                    setDisciplines(res);
                }
            } catch (err) {
                console.error('Failed to load disciplines:', err);
            }
        };

        fetchDisciplines();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const data = await configuration.getProductServices();
            setProductServicesList(data.map((p) => ({ ...p, isNew: false, isDeleted: false })));
        };
        fetchData();
    }, []);

    const handleConfirmResponse = (confirmed) => {
        setIsConfirmOpen(false);
        if (confirmResolveRef.current) {
            confirmResolveRef.current(confirmed);
            confirmResolveRef.current = null;
        }
    };

    /*###############################################
  ############# LK Season #########################
  ###############################################*/
    const initializeSeason = (flex) => {
        seasonGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        // Optional: capture original values for potential diagnostics or rollback
        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalSeason(originalData);

        // Only used to trigger the isChanged state (not storing diffs anymore)
        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            console.log('BeforeEdit (Snapshot)', seasonBeforeSaveRef.current);
            console.log('Edit value', s.activeEditor.value);

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                setIsSeasonChanged(true);
            }
        });
    };

    const handleAddSeason = () => {
        setSeasonBeforeSave(JSON.parse(JSON.stringify(seasonList)));
        setSeasonModalItem({
            id: null,
            description: '',
            abbr: '',
            dateFrom: '',
            dateTo: '',
            position: 0,
            dataKey: '',
            isActive: true,
            comments: '',
            isNew: true,
            isDeleted: false
        });
        setIsSeasonModalOpen(true);
    };

    const handleDeleteSeason = () => {
        const grid = seasonGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        // setSeasonBeforeSave(JSON.parse(JSON.stringify(seasonList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsSeasonChanged(true);
    };

    const validateSeasonItem = (item) => {
        const errors = {};

        if (!item.description || item.description.trim() === '') {
            errors.description = 'Description is required.';
        } else if (item.description.length > 200) {
            errors.description = 'Max 200 characters.';
        }

        if (!item.abbr || item.abbr.trim() === '') {
            errors.abbr = 'Abbreviation is required.';
        } else if (item.abbr.length > 20) {
            errors.abbr = 'Max 20 characters.';
        }

        if (!item.dateFrom) {
            errors.dateFrom = 'Date From is required.';
        }

        if (!item.dateTo) {
            errors.dateTo = 'Date To is required.';
        } else if (item.dateFrom && new Date(item.dateFrom) > new Date(item.dateTo)) {
            errors.dateTo = 'Date To must be after Date From.';
        }

        if (item.position == null || isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        if (item.dataKey && item.dataKey.length > 100) {
            errors.dataKey = 'Max 100 characters.';
        }

        return errors;
    };

    const handleSeasonModalSave = () => {
        const validationErrors = validateSeasonItem(seasonModalItem);
        setSeasonErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setSeasonList((prev) => {
            const isEdit = seasonModalItem.id !== null && !seasonModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === seasonModalItem.id ? { ...seasonModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...seasonModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsSeasonChanged(true);
        setIsSeasonModalOpen(false);
        setSeasonErrors({});
    };

    const handleSaveSeason = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const cleanList = seasonList.map((item) => ({
                ...item,
                id: typeof item.id === 'number' ? item.id : 0,
                description: item.description?.trim() ?? '',
                abbr: item.abbr?.trim() ?? '',
                dateFrom: item.dateFrom,
                dateTo: item.dateTo,
                position: item.position ?? 0,
                dataKey: item.dataKey?.trim() ?? '',
                isActive: item.isActive ?? true,
                comments: item.comments?.trim() ?? '',
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postSeason(cleanList);
            await seasonDataQuery.refetch();

            // seasonBeforeSaveRef.current = JSON.parse(JSON.stringify(cleanList));
            setIsSeasonChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    const trackChanges = (gridRef, setChanges, setChanged, originalData) => {
        const grid = gridRef.current;

        grid.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            if (editedField === 'isActive') {
                editedValue = s.activeEditor.checked;
            }

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                setChanges((prevChanges) => {
                    const updatedChanges = { ...prevChanges };
                    updatedChanges[editedItem.id] = {
                        ...editedItem,
                        [editedField]: editedValue
                    };
                    return updatedChanges;
                });
                setChanged(true);
            }
        });
    };

    /*###############################################
  ############# LK Application Type ###############
  ###############################################*/

    const initializeApplicationType = (flex) => {
        applicationTypeGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalApplicationType(originalData);

        flex.cellEditEnded.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            const newValue = editedItem[editedField];
            const originalValue = originalData[editedItem.id]?.[editedField];

            if (newValue !== originalValue) {
                if (!hasCapturedApplicationTypeSnapshot.current) {
                    setApplicationTypeListBeforeEdit(JSON.parse(JSON.stringify(applicationTypeList)));
                    hasCapturedApplicationTypeSnapshot.current = true;
                }

                setApplicationTypeChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: newValue
                    }
                }));

                setIsApplicationTypeChanged(true);
            }
        });
    };

    const validateApplicationTypeItem = (item) => {
        const errors = {};

        if (item.id == null || isNaN(item.id)) {
            errors.id = 'Id must be a number.';
        } else if (item.id < 0) {
            errors.id = 'Id must be a positive number.';
        }

        if (!item.description || item.description.trim() === '') {
            errors.description = 'Description is required.';
        } else if (item.description.length > 200) {
            errors.description = 'Max 200 characters.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'Abbr must be 50 characters or less.';
        }

        if (item.copyFiles_DataKey && item.copyFiles_DataKey.length > 50) {
            errors.copyFiles_DataKey = 'CopyFiles DataKey must be 50 characters or less.';
        }

        if (item.dataKey && item.dataKey.length > 100) {
            errors.dataKey = 'DataKey must be 100 characters or less.';
        }

        if (item.renderOptions && item.renderOptions.length > 500) {
            errors.renderOptions = 'Render Options must be 500 characters or less.';
        }

        if (item.comments && item.comments.length > 500) {
            errors.comments = 'Comments must be 500 characters or less.';
        }

        if (item.position == null || isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        return errors;
    };

    const handleApplicationTypeModalSave = () => {
        const validationErrors = validateApplicationTypeItem(modalItem);
        setApplicationTypeErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return; // prevent save if any errors
        }

        setApplicationTypeList((prev) => {
            const isEdit = modalItem.id !== null && !modalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === modalItem.id ? { ...modalItem, isNew: false } : item));
            } else {
                return [...prev, { ...modalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsApplicationTypeChanged(true);
        setIsModalOpen(false);
        setApplicationTypeErrors({});
    };

    const handleAddApplicationType = () => {
        setApplicationTypeListBeforeEdit(JSON.parse(JSON.stringify(applicationTypeList)));

        setModalItem({
            id: null,
            description: '',
            abbr: '',
            hint: '',
            position: 0,
            concernAthlete: false,
            concernOfficial: false,
            concernOrganization: false,
            isNewAction: false,
            isEditAction: false,
            copyFiles: true,
            copyFiles_DataKey: '',
            dataKey: '',
            isActive: true,
            comments: '',
            reqKeyB4Submit: false,
            renderOptions: '',
            isNew: true,
            isDeleted: false
        });
        setIsModalOpen(true);
    };

    const handleDeleteApplicationType = () => {
        const grid = applicationTypeGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setApplicationTypeListBeforeEdit(JSON.parse(JSON.stringify(applicationTypeList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsApplicationTypeChanged(true);
    };

    const handleSaveApplicationType = async () => {
        applicationTypeGridRef.current?.finishEditing();

        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

            const cleanList = applicationTypeList.map((item) => ({
                id: Number(item.id) || 0,
                description: sanitize(item.description, 200),
                abbr: sanitize(item.abbr, 50),
                hint: sanitize(item.hint),
                copyFiles_DataKey: sanitize(item.copyFiles_DataKey, 50),
                dataKey: sanitize(item.dataKey, 100),
                renderOptions: sanitize(item.renderOptions, 500),
                concernAthlete: item.concernAthlete ?? false,
                concernOfficial: item.concernOfficial ?? false,
                concernOrganization: item.concernOrganization ?? false,
                isNewAction: item.isNewAction ?? false,
                isEditAction: item.isEditAction ?? false,
                copyFiles: item.copyFiles ?? true,
                reqKeyB4Submit: item.reqKeyB4Submit ?? false,
                isActive: item.isActive ?? false,
                comments: sanitize(item.comments, 500),
                position: item.position ?? 0,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postApplicationType(cleanList);
            await applicationTypeDataQuery.refetch();

            setApplicationTypeChanges({});
            setOriginalApplicationType({});
            setIsApplicationTypeChanged(false);
            hasCapturedApplicationTypeSnapshot.current = false;
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Try again.');
        }
    };

    /*###############################################
  ############# LK Events ###############
  ###############################################*/

    const initializeEvents = (flex) => {
        eventsGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalEvents(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setEventListBeforeEdit(JSON.parse(JSON.stringify(eventList)));
                    hasCapturedBeforeEdit = true;
                }

                setEventsChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsEventChanged(true);
            }
        });
    };

    const validateEventItem = (item) => {
        const errors = {};

        if (item.code == null || isNaN(item.code)) {
            errors.code = 'Code is required and must be a number.';
        }

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'Abbr must be 50 characters or less.';
        }

        if (!item.disciplineId || isNaN(item.disciplineId)) {
            errors.disciplineId = 'Discipline is required.';
        }

        if (item.totalAthletes != null && isNaN(item.totalAthletes)) {
            errors.totalAthletes = 'Total Athletes must be a number.';
        }

        if (item.totalObjects != null && isNaN(item.totalObjects)) {
            errors.totalObjects = 'Total Objects must be a number.';
        }

        return errors;
    };

    const handleAddEvent = () => {
        setEventListBeforeEdit(JSON.parse(JSON.stringify(eventList)));
        setEventModalItem({
            id: null,
            code: 0,
            name: '',
            abbr: '',
            totalAthletes: 0,
            totalObjects: 0,
            isTeam: false,
            isActive: true,
            disciplineId: '',
            isNew: true,
            isDeleted: false,
            resultsFieldsMappingJson: defaultResultsFieldsMapping
        });
        setIsEventModalOpen(true);
    };

    const handleDeleteEvent = () => {
        const grid = eventsGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setEventListBeforeEdit(JSON.parse(JSON.stringify(eventList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsEventChanged(true);
    };

    const handleEventModalSave = () => {
        const validationErrors = validateEventItem(eventModalItem);
        setEventErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setEventList((prev) => {
            const isEdit = eventModalItem.id !== null && !eventModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === eventModalItem.id ? { ...eventModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...eventModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsEventChanged(true);
        setIsEventModalOpen(false);
        setEventErrors({});
    };

    const handleSaveEvent = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

            const cleanList = eventList.map((item) => ({
                id: item.id ?? 0,
                code: item.code ?? 0,
                name: sanitize(item.name, 100),
                abbr: sanitize(item.abbr, 50),
                totalAthletes: item.totalAthletes ?? 0,
                totalObjects: item.totalObjects ?? 0,
                isTeam: item.isTeam ?? false,
                isActive: item.isActive ?? true,
                disciplineId: Number(item.disciplineId) || 0,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false,
                resultsFieldsMappingJson: item.resultsFieldsMappingJson ?? defaultResultsFieldsMapping
            }));

            await configuration.postEvents(cleanList);
            await eventDataQuery.refetch();

            setEventsChanges({});
            setOriginalEvents({});
            setIsEventChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    /*###############################################
  ############# LK Discipline ###############
  ###############################################*/

    const initializeDiscipline = (flex) => {
        disciplineGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginaldiscipline(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setDisciplineListBeforeEdit(JSON.parse(JSON.stringify(disciplineList)));
                    hasCapturedBeforeEdit = true;
                }

                setdisciplineChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsDisciplineChanged(true);
            }
        });
    };

    const validateDisciplineItem = (item) => {
        const errors = {};

        if (item.id != null && isNaN(item.id)) {
            errors.id = 'Id must be a number.';
        }

        if (item.parentId != null && isNaN(item.parentId)) {
            errors.parentId = 'ParentId must be a number.';
        }

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'Abbr must be 50 characters or less.';
        }

        if (item.position != null && isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        if (item.comments && item.comments.length > 500) {
            errors.comments = 'Comments must be 500 characters or less.';
        }

        return errors;
    };

    const handleAddDiscipline = () => {
        setDisciplineListBeforeEdit(JSON.parse(JSON.stringify(disciplineList)));
        setDisciplineModalItem({
            id: null,
            parentId: null,
            name: '',
            abbr: '',
            isActive: true,
            comments: '',
            isNew: true,
            isDeleted: false
        });
        setIsDisciplineModalOpen(true);
    };

    const handleDeleteDiscipline = () => {
        const grid = disciplineGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setDisciplineListBeforeEdit(JSON.parse(JSON.stringify(disciplineList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsDisciplineChanged(true);
    };

    const handleDisciplineModalSave = () => {
        const validationErrors = validateDisciplineItem(disciplineModalItem);
        setDisciplineErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setDisciplineList((prev) => {
            const isEdit = disciplineModalItem.id !== null && !disciplineModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === disciplineModalItem.id ? { ...disciplineModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...disciplineModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsDisciplineChanged(true);
        setIsDisciplineModalOpen(false);
        setDisciplineErrors({});
    };

    const handleSaveDiscipline = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

            const cleanList = disciplineList.map((item) => ({
                id: item.id,
                parentId: item.parentId && item.parentId !== 'null' ? item.parentId : null,
                description: sanitize(item.name, 100),
                abbr: sanitize(item.abbr, 50),
                position: item.position ?? 0,
                isActive: item.isActive ?? true,
                comments: item.comments ?? '',
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postDisciplines(cleanList);
            await disciplineDataQuery.refetch();

            setdisciplineChanges({});
            setOriginaldiscipline({});
            setIsDisciplineChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    /*###############################################
  ############# LK AgeCategories ###############
  ###############################################*/

    const initializeAgeCategory = (flex) => {
        ageCategoryGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalIdAgeCategory(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setAgeCategoryListBeforeEdit(JSON.parse(JSON.stringify(ageCategoryList)));
                    hasCapturedBeforeEdit = true;
                }

                setageCategoryChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsAgeCategoryChanged(true);
            }
        });
    };

    const validateAgeCategoryItem = (item) => {
        const errors = {};

        if (item.code == null || isNaN(item.code)) {
            errors.code = 'Code is required and must be a number.';
        }

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.ageFrom == null || isNaN(item.ageFrom)) {
            errors.ageFrom = 'AgeFrom is required and must be a number.';
        }

        if (item.ageTo == null || isNaN(item.ageTo)) {
            errors.ageTo = 'AgeTo is required and must be a number.';
        }

        if (item.rAgeTo == null || isNaN(item.rAgeTo)) {
            errors.rAgeTo = 'RAgeTo is required and must be a number.';
        }

        if (item.rAgeFrom == null || isNaN(item.rAgeFrom)) {
            errors.rAgeFrom = 'RAgeFrom is required and must be a number.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'Abbr must be 50 characters or less.';
        }

        if (item.gender && item.gender.length != 1) {
            errors.gender = 'Abbr must be 1 character.';
        }

        if (item.position != null && isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        return errors;
    };

    const handleAddAgeCategory = () => {
        setAgeCategoryListBeforeEdit(JSON.parse(JSON.stringify(ageCategoryList)));
        setAgeCategoryModalItem({
            code: null,
            name: '',
            abbr: '',
            gender: 'X',
            ageFrom: null,
            ageTo: null,
            rAgeFrom: null,
            rAgeTo: null,
            position: null,
            isActive: true,
            isNew: true,
            isDeleted: false
        });
        setIsAgeCategoryModalOpen(true);
    };

    const handleDeleteAgeCategory = () => {
        const grid = ageCategoryGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setAgeCategoryListBeforeEdit(JSON.parse(JSON.stringify(ageCategoryList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsAgeCategoryChanged(true);
    };

    const handleAgeCategoryModalSave = () => {
        const validationErrors = validateAgeCategoryItem(AgeCategoryModalItem);
        setAgeCategoryErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setageCategoryList((prev) => {
            const isEdit = AgeCategoryModalItem.id !== null && !AgeCategoryModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === AgeCategoryModalItem.id ? { ...AgeCategoryModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...AgeCategoryModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsAgeCategoryChanged(true);
        setIsAgeCategoryModalOpen(false);
        setAgeCategoryErrors({});
    };

    const handleSaveAgeCategory = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

            const cleanList = ageCategoryList.map((item) => ({
                id: item.id,
                code: item.code ?? 0,
                name: sanitize(item.name, 100),
                abbr: sanitize(item.abbr, 50),
                gender: sanitize(item.gender, 1),
                ageFrom: item.ageFrom,
                ageTo: item.ageTo,
                rAgeFrom: item.rAgeFrom,
                rAgeTo: item.rAgeTo,
                position: item.position ?? 0,
                isActive: item.isActive ?? true,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postAgeCategories(cleanList);
            await ageCategoryDataQuery.refetch();

            setageCategoryChanges({});
            setOriginalIdAgeCategory({});
            setIsAgeCategoryChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    /*###############################################
  ############# LK Divisions ###############
  ###############################################*/

    const initializeDivision = (flex) => {
        divisionGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalIdDivision(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setDivisionListBeforeEdit(JSON.parse(JSON.stringify(divisionList)));
                    hasCapturedBeforeEdit = true;
                }

                setdivisionChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsDivisionChanged(true);
            }
        });
    };

    const validateDivisionItem = (item) => {
        const errors = {};

        if (item.disciplineId == null || isNaN(item.disciplineId)) {
            errors.disciplineId = 'DisciplineId is required and must be a number.';
        }

        if (item.eventId == null || isNaN(item.eventId)) {
            errors.eventId = 'EventId is required and must be a number.';
        }

        if (item.ageCategoryId == null || isNaN(item.ageCategoryId)) {
            errors.ageCategoryId = 'AgeCategoryId is required and must be a number.';
        }

        if (item.competitionTypeId == null || isNaN(item.competitionTypeId)) {
            errors.competitionTypeId = 'CompetitionTypeId is required and must be a number.';
        }

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.abbr && item.abbr.length > 50) {
            errors.abbr = 'Abbr must be 50 characters or less.';
        }

        if (item.position != null && isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        return errors;
    };

    const handleAddDivision = () => {
        setDivisionListBeforeEdit(JSON.parse(JSON.stringify(divisionList)));
        setDivisionModalItem({
            disciplineId: null,
            eventId: null,
            ageCategoryId: null,
            competitionTypeId: null,
            name: '',
            abbr: '',
            position: null,
            isNew: true,
            isDeleted: false
        });
        setIsDivisionModalOpen(true);
    };

    const handleDeleteDivision = () => {
        const grid = divisionGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setDivisionListBeforeEdit(JSON.parse(JSON.stringify(divisionList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsDivisionChanged(true);
    };

    const handleDivisionModalSave = () => {
        const validationErrors = validateDivisionItem(DivisionModalItem);
        setDivisionErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setdivisionList((prev) => {
            const isEdit = DivisionModalItem.id !== null && !DivisionModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === DivisionModalItem.id ? { ...DivisionModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...DivisionModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsDivisionChanged(true);
        setIsDivisionModalOpen(false);
        setDivisionErrors({});
    };

    const handleSaveDivision = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

            const cleanList = divisionList.map((item) => ({
                disciplineId: item.disciplineId,
                eventId: item.eventId,
                ageCategoryId: item.ageCategoryId,
                competitionTypeId: item.competitionTypeId,
                name: sanitize(item.name, 100),
                abbr: sanitize(item.abbr, 50),
                position: item.position ?? 0,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postDivisions(cleanList);
            await divisionDataQuery.refetch();

            setdivisionChanges({});
            setOriginalIdDivision({});
            setIsDivisionChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    /*###############################################
  ############# LK CompetitionTypes ###############
  ###############################################*/

    const initializeCompetitionTypes = (flex) => {
        competitionTypeGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalIdCompetitionType(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setCompetitionTypeListBeforeEdit(JSON.parse(JSON.stringify(competitionTypeList)));
                    hasCapturedBeforeEdit = true;
                }

                setcompetitionTypeChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsCompetitionTypeChanged(true);
            }
        });
    };

    const validateCompetitionTypeItem = (item) => {
        const errors = {};

        if (!item.name || item.name.trim() === '') {
            errors.name = 'Name is required.';
        } else if (item.name.length > 100) {
            errors.name = 'Name must be 100 characters or less.';
        }

        if (item.abbr && item.abbr.length > 15) {
            errors.abbr = 'Abbr must be 15 characters or less.';
        }

        if (item.position != null && isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        return errors;
    };

    const handleAddCompetitionType = () => {
        setCompetitionTypeListBeforeEdit(JSON.parse(JSON.stringify(competitionTypeList)));
        setCompetitionTypeModalItem({
            name: '',
            abbr: '',
            position: null,
            isActive: true,
            comments: '',
            isNew: true,
            isDeleted: false
        });
        setIsCompetitionTypeModalOpen(true);
    };

    const handleDeleteCompetitionType = () => {
        const grid = competitionTypeGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setCompetitionTypeListBeforeEdit(JSON.parse(JSON.stringify(competitionTypeList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsCompetitionTypeChanged(true);
    };

    const handleCompetitionTypeModalSave = () => {
        const validationErrors = validateCompetitionTypeItem(CompetitionTypeModalItem);
        setCompetitionTypeErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setcompetitionTypeList((prev) => {
            const isEdit = CompetitionTypeModalItem.id !== null && !CompetitionTypeModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === CompetitionTypeModalItem.id ? { ...CompetitionTypeModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...CompetitionTypeModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsCompetitionTypeChanged(true);
        setIsCompetitionTypeModalOpen(false);
        setCompetitionTypeErrors({});
    };

    const handleSaveCompetitionType = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

            const cleanList = competitionTypeList.map((item) => ({
                id: item.id,
                description: sanitize(item.name, 100),
                abbr: sanitize(item.abbr, 50),
                position: item.position,
                comments: item.comments,
                isActive: item.isActive,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted
            }));

            await configuration.postCompetitionTypes(cleanList);
            await competitionTypeDataQuery.refetch();

            setcompetitionTypeChanges({});
            setOriginalIdCompetitionType({});
            setIsCompetitionTypeChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    /*###############################################
  ############# LK EventCategories ###############
  ###############################################*/

    const initializeEventCategory = (flex) => {
        eventCategoryGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalIdEventCategory(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setEventCategoryListBeforeEdit(JSON.parse(JSON.stringify(eventCategoryList)));
                    hasCapturedBeforeEdit = true;
                }

                seteventCategoryChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));

                setIsEventCategoryChanged(true);
            }
        });
    };

    const validateEventCategoryItem = (item) => {
        const errors = {};

        if (item.eventId == null || isNaN(item.eventId)) {
            errors.eventId = 'EventId is required and must be a number.';
        }

        if (item.ageCategoryId == null || isNaN(item.ageCategoryId)) {
            errors.ageCategoryId = 'AgeCategoryId is required and must be a number.';
        }

        if (item.divisionId == null || isNaN(item.divisionId)) {
            errors.divisionId = 'DivisionId is required and must be a number.';
        }

        if (item.additionalDescr && item.additionalDescr.length > 50) {
            errors.additionalDescr = 'AdditionalDescr must be 50 characters or less.';
        }

        if (item.distanceFrom == null || isNaN(item.distanceFrom)) {
            errors.distanceFrom = 'DistanceFrom is required and must be a number.';
        }

        if (item.distanceTo == null || isNaN(item.distanceTo)) {
            errors.distanceTo = 'DistanceTo is required and must be a number.';
        }

        if (item.distanceDescr && item.distanceDescr.length > 50) {
            errors.distanceDescr = 'DistanceDescr must be 50 characters or less.';
        }

        if (item.weightFrom == null || isNaN(item.weightFrom)) {
            errors.weightFrom = 'WeightFrom is required and must be a number.';
        }

        if (item.weightTo == null || isNaN(item.weightTo)) {
            errors.weightTo = 'WeightTo is required and must be a number.';
        }

        if (item.weightDescr && item.weightDescr.length > 50) {
            errors.weightDescr = 'WeightDescr must be 50 characters or less.';
        }

        if (item.heightFrom == null || isNaN(item.heightFrom)) {
            errors.heightFrom = 'HeightFrom is required and must be a number.';
        }

        if (item.heightTo == null || isNaN(item.heightTo)) {
            errors.heightTo = 'HeightTo is required and must be a number.';
        }

        if (item.heightDescr && item.heightDescr.length > 50) {
            errors.heightDescr = 'HeightDescr must be 50 characters or less.';
        }

        return errors;
    };

    const handleAddEventCategory = () => {
        setEventCategoryListBeforeEdit(JSON.parse(JSON.stringify(eventCategoryList)));
        setEventCategoryModalItem({
            eventId: null,
            ageCategoryId: null,
            divisionId: null,
            additionalDescr: '',
            isOlympic: false,
            distanceFrom: null,
            distanceTo: null,
            distanceDescr: '',
            weightFrom: null,
            weightTo: null,
            weightDescr: '',
            heightFrom: null,
            heightTo: null,
            heightDescr: '',
            isNew: true,
            isDeleted: false
        });
        setIsEventCategoryModalOpen(true);
    };

    const handleDeleteEventCategory = () => {
        const grid = eventCategoryGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setEventCategoryListBeforeEdit(JSON.parse(JSON.stringify(eventCategoryList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsEventCategoryChanged(true);
    };

    const handleEventCategoryModalSave = () => {
        const validationErrors = validateEventCategoryItem(EventCategoryModalItem);
        setEventCategoryErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        seteventCategoryList((prev) => {
            const isEdit = EventCategoryModalItem.id !== null && !EventCategoryModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === EventCategoryModalItem.id ? { ...EventCategoryModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...EventCategoryModalItem, isNew: true, isDeleted: false }];
            }
        });

        setIsEventCategoryChanged(true);
        setIsEventCategoryModalOpen(false);
        setEventCategoryErrors({});
    };

    const handleSaveEventCategory = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;

        try {
            const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

            const cleanList = eventCategoryList.map((item) => ({
                id: item.id,
                eventId: item.eventId,
                ageCategoryId: item.ageCategoryId,
                divisionId: item.divisionId === 'null' ? null : item.divisionId,
                additionalDescr: item.additionalDescr === 'null' ? null : sanitize(item.additionalDescr, 50),
                distanceFrom: item.distanceFrom === 'null' ? null : item.distanceFrom,
                distanceTo: item.distanceTo === 'null' ? null : item.distanceTo,
                distanceDescr: item.distanceDescr === 'null' ? null : sanitize(item.distanceDescr, 50),
                weightFrom: item.weightFrom === 'null' ? null : item.weightFrom,
                weightTo: item.weightTo === 'null' ? null : item.weightTo,
                weightDescr: item.weightDescr === 'null' ? null : sanitize(item.weightDescr, 50),
                heightFrom: item.heightFrom === 'null' ? null : item.heightFrom,
                heightTo: item.heightTo === 'null' ? null : item.heightTo,
                heightDescr: item.heightDescr === 'null' ? null : sanitize(item.heightDescr, 50),
                isOlympic: item.isOlympic ?? false,
                isNew: item.isNew,
                isDeleted: item.isDeleted
            }));

            await configuration.postEventCategories(cleanList);
            await eventCategoryDataQuery.refetch();

            seteventCategoryChanges({});
            setOriginalIdEventCategory({});
            setIsEventCategoryChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    //When I press "next 50" in the event categories
    //loads the next 50 items from the api
    const next50Items = async () => {
        setLimit((prevLimit) => {
            const newLimit = prevLimit + 50;
            const paginated = eventCategoryList.slice(start, newLimit);
            setPaginatedEventCategories(paginated);
            console.log('New limit:', newLimit);
            console.log('Paginated items:', paginated);

            console.log(paginated.length, eventCategoryList.length);

            if (paginated.length == eventCategoryList.length) {
                setPaginationEnded(true);
            }

            return newLimit;
        });
    };

    /*###############################################
  ######### Application Type Product Ages #########
  ###############################################*/

    const initializeApplicationTypeProductAges = (flex) => {
        applicationTypeProductAgesGridRef.current = flex;
        flex.itemsSourceChanged.addHandler((grid) => {
            if (!isNil(grid.collectionView)) grid.collectionView.trackChanges = true;
        });

        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;
        const originalData = {};
        flex.collectionView?.itemsEdited.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalApplicationTypeProductAges(originalData);

        trackChanges(
            applicationTypeProductAgesGridRef,
            setApplicationTypeProductAgesChanges,
            setIsApplicationTypeProductAgesChanged,
            originalData
        );
    };

    /*###############################################
  ######### Application Type Product Services #########
  ###############################################*/

    const initializeApplicationTypeProductServices = (flex) => {
        applicationTypeProductServicesGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalApplicationTypeProductServices(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setApplicationTypeProductServicesBeforeEdit(JSON.parse(JSON.stringify(applicationTypeProductServicesList)));
                    hasCapturedBeforeEdit = true;
                }

                setApplicationTypeProductServicesChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsApplicationTypeProductServicesChanged(true);
            }
        });
    };

    const validateProductServiceItem = (item) => {
        const errors = {};

        if (item.applicationTypeId == null || isNaN(item.applicationTypeId)) {
            errors.applicationTypeId = 'Application Type is required.';
        } else if (item.applicationTypeId < 0) {
            errors.applicationTypeId = 'Id must be a positive number';
        }

        if (!item.productServiceId || isNaN(item.productServiceId)) {
            errors.productServiceId = 'Product Service is required.';
        }

        if (!item.transTypeId || isNaN(item.transTypeId)) {
            errors.transTypeId = 'Transaction Type is required.';
        }

        if (item.unitPrice != null && isNaN(item.unitPrice)) {
            errors.unitPrice = 'Unit Price must be a valid number.';
        } else if (item.unitPrice < 0) {
            errors.unitPrice = 'Unit Price must be a positive number';
        }

        if (item.vatPerc != null && isNaN(item.vatPerc)) {
            errors.vatPerc = 'VAT must be a valid number.';
        } else if (item.vatPerc < 0) {
            errors.vatPerc = 'Vat must be a positive number';
        }

        if (item.validFrom && item.validTo && new Date(item.validFrom) > new Date(item.validTo)) {
            errors.validTo = 'Valid To must be after Valid From.';
        }

        return errors;
    };

    const handleAddApplicationTypeProductService = () => {
        setApplicationTypeProductServicesBeforeEdit(JSON.parse(JSON.stringify(applicationTypeProductServicesList)));
        setAppTypeProductServicesModalItem({
            id: null,
            applicationTypeId: null,
            productServiceId: null,
            applicationAuditStatusId: null,
            personAuditStatusId: null,
            transTypeId: null,
            validFrom: '',
            validTo: '',
            unitPrice: null,
            vatPerc: null,
            isActive: true,
            isNew: true,
            isDeleted: false
        });
        setIsAppTypeProductServicesModalOpen(true);
    };

    const handleDeleteApplicationTypeProductService = () => {
        const grid = applicationTypeProductServicesGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setApplicationTypeProductServicesBeforeEdit(JSON.parse(JSON.stringify(applicationTypeProductServicesList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsApplicationTypeProductServicesChanged(true);
    };

    const handleApplicationTypeProductServiceModalSave = () => {
        const validationErrors = validateProductServiceItem(appTypeProductServicesModalItem);
        setAppTypeProductServicesErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        const appType = applicationTypeList.find((a) => a.id === appTypeProductServicesModalItem.applicationTypeId);
        const prodService = productServicesList.find((p) => p.id === appTypeProductServicesModalItem.productServiceId);

        const enrichedItem = {
            ...appTypeProductServicesModalItem,
            applicationTypeTitle: appType?.description || `App#${appTypeProductServicesModalItem.applicationTypeId}`,
            productServiceTitle: prodService?.description || `PS#${appTypeProductServicesModalItem.productServiceId}`,
            isNew: appTypeProductServicesModalItem.isNew ?? true,
            isDeleted: false
        };

        setApplicationTypeProductServicesList((prev) => {
            const isEdit = enrichedItem.id !== null && !enrichedItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === enrichedItem.id ? enrichedItem : item));
            } else {
                return [...prev, enrichedItem];
            }
        });

        setIsApplicationTypeProductServicesChanged(true);
        setIsAppTypeProductServicesModalOpen(false);
        setAppTypeProductServicesErrors({});
    };

    const handleSaveApplicationTypeProductServices = async () => {
        try {
            const confirmed = await confirmSave();
            if (!confirmed) return;
            const cleanList = applicationTypeProductServicesList.map((item) => ({
                id: item.id ?? 0,
                applicationTypeId: item.applicationTypeId ?? 0,
                productServiceId: item.productServiceId ?? 0,
                applicationAuditStatusId: item.applicationAuditStatusId ?? null,
                personAuditStatusId: item.personAuditStatusId ?? null,
                transTypeId: item.transTypeId ?? 1,
                unitPrice: parseFloat(item.unitPrice) || 0,
                vatPerc: parseFloat(item.vatPerc) || 0,
                validFrom: item.validFrom ?? null,
                validTo: item.validTo ?? null,
                isActive: item.isActive ?? true,
                applicationStatusId: item.applicationStatusId ?? null,
                personStatusId: item.personStatusId ?? null,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postApplicationTypeProductServices(cleanList);
            await applicationTypeProductServicesDataQuery.refetch();

            setApplicationTypeProductServicesChanges({});
            setOriginalApplicationTypeProductServices({});
            setIsApplicationTypeProductServicesChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    /*###############################################
  ################ Product Services ###############
  ###############################################*/

    const initializeProductServices = (flex) => {
        productServicesGridRef.current = flex;

        if (!isNil(flex.collectionView)) {
            flex.collectionView.trackChanges = true;
        }

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalProductServices(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalData[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setProductServicesBeforeEdit(JSON.parse(JSON.stringify(productServicesList)));
                    hasCapturedBeforeEdit = true;
                }

                setProductServicesChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsProductServicesChanged(true);
            }
        });
    };

    const handleAddProductService = () => {
        setProductServicesBeforeEdit(JSON.parse(JSON.stringify(productServicesList)));

        const newItem = {
            id: null,
            description: '',
            abbr: '',
            code: '',
            unitPrice: 0,
            vatPerc: 0,
            position: 0,
            isActive: true,
            isUniquePerEntity: false,
            isNew: true,
            isDeleted: false
        };

        setProductServicesModalItem(newItem);
        setIsProductServicesModalOpen(true);
    };

    const handleDeleteProductService = () => {
        const grid = productServicesGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setProductServicesBeforeEdit(JSON.parse(JSON.stringify(productServicesList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsProductServicesChanged(true);
    };

    const handleSaveProductServices = async () => {
        try {
            const confirmed = await confirmSave();
            if (!confirmed) return;

            const cleanList = productServicesList.map((item) => ({
                id: item.id ?? 0,
                description: item.description || '',
                abbr: item.abbr || '',
                code: item.code || '',
                unitPrice: parseFloat(item.unitPrice) || 0,
                vatPerc: parseFloat(item.vatPerc) || 0,
                position: item.position ?? 0,
                isActive: item.isActive ?? true,
                isUniquePerEntity: item.isUniquePerEntity ?? false,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postProductServices(cleanList);
            const refreshed = await configuration.getProductServices();
            setProductServicesList(refreshed.map((p) => ({ ...p, isNew: false, isDeleted: false })));

            setProductServicesChanges({});
            setOriginalProductServices({});
            setIsProductServicesChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    const handleProductServicesModalSave = () => {
        const updatedList = [...productServicesList];
        const index = updatedList.findIndex((p) => p.id === productServicesModalItem.id);

        if (index > -1) {
            // Update existing
            updatedList[index] = { ...productServicesModalItem };
        } else {
            // Add new
            updatedList.push(productServicesModalItem);
        }

        setProductServicesList(updatedList);
        setIsProductServicesChanged(true);
        setIsProductServicesModalOpen(false);
    };

    /*###############################################
  ################ LK File Types##################
  ###############################################*/

    const initializeFileTypes = (flex) => {
        fileTypesGridRef.current = flex;
        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalFileTypes(originalData);

        let hasCapturedBeforeEdit = false;

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalFileTypes[editedItem.id]?.[editedField];
            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedBeforeEdit) {
                    setFileTypesBeforeEdit(JSON.parse(JSON.stringify(fileTypesList)));
                    hasCapturedBeforeEdit = true;
                }

                setFileTypesChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsFileTypesChanged(true);
            }
        });
    };

    const validateFileTypeItem = (item) => {
        const errors = {};

        if (!item.code || item.code.trim() === '') {
            errors.code = 'Code is required.';
        } else if (item.code.length > 20) {
            errors.code = 'Max 20 characters.';
        }

        if (!item.descr || item.descr.trim() === '') {
            errors.descr = 'Description is required.';
        } else if (item.descr.length > 100) {
            errors.descr = 'Max 100 characters.';
        }

        if (item.abbr && item.abbr.length > 20) {
            errors.abbr = 'Abbr must be 20 characters or less.';
        }

        if (item.dataKey && item.dataKey.length > 50) {
            errors.dataKey = 'DataKey must be 50 characters or less.';
        }

        if (item.tableRef && item.tableRef.length > 50) {
            errors.tableRef = 'TableRef must be 50 characters or less.';
        }

        if (item.comments && item.comments.length > 500) {
            errors.comments = 'Comments must be 500 characters or less.';
        }

        if (item.templates && item.templates.length > 500) {
            errors.templates = 'Templates must be 500 characters or less.';
        }

        const lblFields = ['lblDateFrom', 'lblDateTo', 'lblIssuedAt', 'lblIssuedBy', 'lblNumber', 'lblComments'];
        for (const field of lblFields) {
            if (item[field] && item[field].length > 50) {
                errors[field] = `${field} must be 50 characters or less.`;
            }
        }

        if (item.position != null && isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        }

        return errors;
    };

    const handleAddFileType = () => {
        setFileTypesBeforeEdit(JSON.parse(JSON.stringify(fileTypesList)));
        setFileTypeModalItem({
            id: null,
            code: '',
            descr: '',
            abbr: '',
            dataKey: '',
            tableRef: '',
            position: 1,
            isActive: true,
            comments: '',
            lblDateFrom: '',
            lblDateTo: '',
            lblIssuedAt: '',
            lblIssuedBy: '',
            lblNumber: '',
            lblComments: '',
            lkCommonParentId: null,
            pfeTypeId: null,
            copyToPF: false,
            templates: '',
            isNew: true,
            isDeleted: false
        });
        setIsFileTypeModalOpen(true);
    };

    const handleDeleteFileType = () => {
        const grid = fileTypesGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setFileTypesBeforeEdit(JSON.parse(JSON.stringify(fileTypesList)));

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsFileTypesChanged(true);
    };

    const handleSaveFileTypes = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;
        try {
            const sanitize = (val, max = 200, fallback = '') => (typeof val === 'string' ? val.trim().substring(0, max) : fallback);

            const cleanList = fileTypesList.map((item) => ({
                id: item.id ?? 0,
                code: sanitize(item.code, 20),
                descr: sanitize(item.descr, 100),
                abbr: sanitize(item.abbr, 20),
                dataKey: sanitize(item.dataKey, 50),
                tableRef: sanitize(item.tableRef, 50),
                position: item.position ?? 1,
                isActive: item.isActive ?? true,
                comments: sanitize(item.comments, 500),
                lblDateFrom: sanitize(item.lblDateFrom, 50),
                lblDateTo: sanitize(item.lblDateTo, 50),
                lblIssuedAt: sanitize(item.lblIssuedAt, 50),
                lblIssuedBy: sanitize(item.lblIssuedBy, 50),
                lblNumber: sanitize(item.lblNumber, 50),
                lblComments: sanitize(item.lblComments, 50),
                lkCommonParentId: item.lkCommonParentId ?? null,
                pfeTypeId: item.pfeTypeId ?? null,
                copyToPF: item.copyToPF ?? false,
                templates: sanitize(item.templates, 500),
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postFileTypes(cleanList);
            await fileTypesDataQuery.refetch();

            setFileTypesChanges({});
            setIsFileTypesChanged(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    const handleFileTypeModalSave = () => {
        const validationErrors = validateFileTypeItem(fileTypeModalItem);
        setFileTypesErrors(validationErrors); // Add this state if not already declared

        if (Object.keys(validationErrors).length > 0) {
            return;
        }

        setFileTypesList((prev) => {
            const isEdit = fileTypeModalItem.id !== null && !fileTypeModalItem.isNew;
            const updated = { ...fileTypeModalItem, isNew: false, isDeleted: false };
            return isEdit
                ? prev.map((item) => (item.id === fileTypeModalItem.id ? updated : item))
                : [...prev, { ...updated, isNew: true }];
        });

        setIsFileTypesChanged(true);
        setIsFileTypeModalOpen(false);
        setFileTypesErrors({});
    };

    /*###############################################
  ############# LK Optional Answers ##############
  ###############################################*/

    const initializeOptionalAnswers = (flex) => {
        optionalAnswersGridRef.current = flex;
        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalOptionalAnswers(originalData);

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalOptionalAnswers[editedItem.id]?.[editedField];
            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedOptionalAnswerSnapshot) {
                    setOptionalAnswersBeforeEdit(JSON.parse(JSON.stringify(optionalAnswersList)));
                    setHasCapturedOptionalAnswerSnapshot(true);
                }

                setOptionalAnswerChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsOptionalAnswerChanged(true);
            }
        });
    };

    const validateOptionalAnswerItem = (item) => {
        const errors = {};

        if (!item.title || item.title.trim() === '') {
            errors.title = 'Title is required.';
        }

        if (item.title?.length > 200) {
            errors.title = 'Max 200 characters.';
        }

        if (item.position == null || isNaN(item.position)) {
            errors.position = 'Position must be a number.';
        } else if (item.position < 0) {
            errors.position = 'Position must be a positive number.';
        }

        if (!item.questionId) {
            errors.questionId = 'Question is required.';
        }

        if (item.optionalAnswerCode1?.length > 50) {
            errors.optionalAnswerCode1 = 'Code 1 must be max 50 characters.';
        }

        if (item.optionalAnswerCode2?.length > 50) {
            errors.optionalAnswerCode2 = 'Code 2 must be max 50 characters.';
        }

        return errors;
    };

    // Add Optional Answer
    const handleAddOptionalAnswer = () => {
        setOptionalAnswersBeforeEdit(JSON.parse(JSON.stringify(optionalAnswersList))); // snapshot
        setHasCapturedOptionalAnswerSnapshot(true);

        setOptionalAnswerModalItem({
            id: crypto.randomUUID(),
            questionId: '',
            title: '',
            isCorrect: false,
            position: 0,
            statusId: 1,
            isActive: true,
            isDisabled: false,
            optionalAnswerCode1: '',
            optionalAnswerCode2: '',
            createdAt: new Date().toISOString(),
            isNew: true,
            isDeleted: false
        });
        setIsOptionalAnswerModalOpen(true);
    };

    const handleDeleteOptionalAnswer = () => {
        const grid = optionalAnswersGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setOptionalAnswersBeforeEdit(JSON.parse(JSON.stringify(optionalAnswersList)));
        setHasCapturedOptionalAnswerSnapshot(true);

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsOptionalAnswerChanged(true);
    };

    const handleOptionalAnswerModalSave = () => {
        const validationErrors = validateOptionalAnswerItem(optionalAnswerModalItem);
        setOptionalAnswerErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        const selectedQuestion = questionList.find((q) => q.id === optionalAnswerModalItem.questionId);

        const enrichedItem = {
            ...optionalAnswerModalItem,
            questionTitle: selectedQuestion?.title ?? `Q#${optionalAnswerModalItem.questionId}`,
            isNew: optionalAnswerModalItem.isNew ?? true,
            isDeleted: false
        };

        setOptionalAnswersList((prev) => {
            const isEdit = optionalAnswerModalItem.id && !optionalAnswerModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === optionalAnswerModalItem.id ? enrichedItem : item));
            } else {
                return [...prev, enrichedItem];
            }
        });

        setIsOptionalAnswerChanged(true);
        setIsOptionalAnswerModalOpen(false);
        setOptionalAnswerErrors({});
    };

    const handleSaveOptionalAnswers = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;
        try {
            const grid = optionalAnswersGridRef.current;
            if (grid?.collectionView) grid.finishEditing();

            const cleanList = optionalAnswersList.map((item) => ({
                ...item,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postOptionalAnswers(cleanList);
            await optionalAnswerDataQuery.refetch(); // refresh

            setOptionalAnswerChanges({});
            setIsOptionalAnswerChanged(false);

            if (grid?.collectionView) {
                grid.collectionView.itemsAdded.length = 0;
                grid.collectionView.itemsRemoved.length = 0;
                grid.collectionView.itemsEdited.length = 0;
            }
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    /*###############################################
  ################ LK Question ####################
  ###############################################*/

    const initializeQuestions = (flex) => {
        questionsGridRef.current = flex;
        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;

        const originalData = {};
        flex.collectionView.items.forEach((item) => {
            originalData[item.id] = { ...item };
        });
        setOriginalQuestions(originalData);

        flex.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            const originalValue = originalQuestions[editedItem.id]?.[editedField];

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                if (!hasCapturedQuestionSnapshot) {
                    setQuestionListBeforeEdit(JSON.parse(JSON.stringify(questionList)));
                    setHasCapturedQuestionSnapshot(true);
                }

                setQuestionChanges((prev) => ({
                    ...prev,
                    [editedItem.id]: {
                        ...editedItem,
                        [editedField]: editedValue
                    }
                }));
                setIsQuestionChanged(true);
            }
        });
    };

    const validateQuestionItem = (item) => {
        const errors = {};

        if (!item.code || item.code.trim() === '') {
            errors.code = 'Code is required.';
        } else if (item.code.length > 50) {
            errors.code = 'Code must be 50 characters or less.';
        }

        if (!item.title || item.title.trim() === '') {
            errors.title = 'Title is required.';
        } else if (item.title.length > 100) {
            errors.title = 'Title must be 100 characters or less.';
        }

        if (item.description && item.description.length > 500) {
            errors.description = 'Description must be 500 characters or less.';
        }

        if (!item.typeId || isNaN(item.typeId)) {
            errors.typeId = 'Question Type is required.';
        }

        if (item.limitLow != null && isNaN(item.limitLow)) {
            errors.limitLow = 'Limit Low must be a valid number.';
        }

        if (item.limitHigh != null && isNaN(item.limitHigh)) {
            errors.limitHigh = 'Limit High must be a valid number.';
        }

        return errors;
    };

    const handleAddQuestion = () => {
        setQuestionListBeforeEdit(JSON.parse(JSON.stringify(questionList)));
        setHasCapturedQuestionSnapshot(true);
        setQuestionModalItem({
            id: crypto.randomUUID(),
            code: '',
            title: '',
            description: '',
            typeId: null,
            acceptsMultipleAnswers: false,
            isInteger: false,
            limitLow: null,
            limitHigh: null,
            hasCorrectAnswers: false,
            createdAt: new Date().toISOString(),
            isNew: true,
            isDeleted: false
        });
        setIsQuestionModalOpen(true);
    };

    const handleDeleteQuestion = () => {
        const grid = questionsGridRef.current;
        if (!grid) return;

        const selected = grid.collectionView.currentItem;
        if (!selected) return;

        setQuestionListBeforeEdit(JSON.parse(JSON.stringify(questionList)));
        setHasCapturedQuestionSnapshot(true);

        selected.isDeleted = true;
        grid.collectionView.refresh();
        setIsQuestionChanged(true);
    };

    const handleSaveQuestions = async () => {
        const confirmed = await confirmSave();
        if (!confirmed) return;
        try {
            const cleanList = questionList.map((item) => ({
                ...item,
                isNew: item.isNew ?? false,
                isDeleted: item.isDeleted ?? false
            }));

            await configuration.postQuestion(cleanList);

            const { data: updatedData } = await questionDataQuery.refetch(); // use returned data
            const freshData = updatedData.map((item) => ({
                ...item,
                isNew: false,
                isDeleted: false
            }));

            setQuestionList(freshData);
            setOriginalQuestions(Object.fromEntries(freshData.map((item) => [item.id, { ...item }])));
            setLastCommittedQuestions(freshData);

            setQuestionChanges({});
            setIsQuestionChanged(false);
            setHasCapturedQuestionSnapshot(false);
        } catch (err) {
            console.error('Save failed:', err);
            alert('Save failed. Please try again.');
        }
    };

    const handleQuestionModalSave = () => {
        const validationErrors = validateQuestionItem(questionModalItem);
        setQuestionErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        setQuestionList((prev) => {
            const isEdit = questionModalItem.id && !questionModalItem.isNew;
            if (isEdit) {
                return prev.map((item) => (item.id === questionModalItem.id ? { ...questionModalItem, isNew: false } : item));
            } else {
                return [...prev, { ...questionModalItem, isNew: true }];
            }
        });

        setIsQuestionModalOpen(false);
        setIsQuestionChanged(true);
        setQuestionErrors({});
    };

    return {
        loading: <p> loading </p>,
        success: (
            <>
                <div style={{ textAlign: 'center', fontSize: 30, fontWeight: 'bold', margin: '20px' }}>
                    <h1>Checklist</h1>
                </div>

                <SimpleAccordion
                    title={<Typography variant="h6">LK Season</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK Season</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddSeason} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteSeason}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    // Ensure any in-progress edit is committed before reset
                    seasonGridRef.current?.finishEditing();

                    const restored = JSON.parse(JSON.stringify(seasonBeforeSaveRef.current));
                    setSeasonList(restored);
                    setIsSeasonChanged(false);
                    seasonGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isSeasonChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeSeason(flex)}
                                className="explorer-grid"
                                itemsSource={seasonList
                                    .filter((item) => !item.isDeleted)
                                    .map((item) => ({ ...item, position: item.position.toString() }))}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Περιγραφή" binding="description" width="*" />
                                <FlexGridColumn header="Έναρξη" binding="dateFrom" width="*" />
                                <FlexGridColumn header="Λήξη" binding="dateTo" width="*" />
                                <FlexGridColumn header="Ενεργή" binding="isActive" width="*" />
                                <FlexGridColumn header="θέση" binding="position" width="*" align="left" />
                            </FlexGrid>
                            <Dialog open={isSeasonModalOpen} onClose={() => setIsSeasonModalOpen(false)} maxWidth="md" fullWidth>
                                <DialogTitle>Edit Season</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Description"
                                        value={seasonModalItem?.description || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, description: e.target.value })}
                                        error={!!seasonErrors.description}
                                        helperText={seasonErrors.description}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={seasonModalItem?.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, abbr: e.target.value })}
                                        error={!!seasonErrors.abbr}
                                        helperText={seasonErrors.abbr}
                                    />
                                    <TextField
                                        label="Date From"
                                        type="date"
                                        value={seasonModalItem?.dateFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, dateFrom: e.target.value })}
                                        error={!!seasonErrors.dateFrom}
                                        helperText={seasonErrors.dateFrom}
                                    />
                                    <TextField
                                        label="Date To"
                                        type="date"
                                        value={seasonModalItem?.dateTo || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, dateTo: e.target.value })}
                                        error={!!seasonErrors.dateTo}
                                        helperText={seasonErrors.dateTo}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={seasonModalItem?.position || 0}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, position: Number(e.target.value) })}
                                        error={!!seasonErrors.position}
                                        helperText={seasonErrors.position}
                                    />
                                    <TextField
                                        label="DataKey"
                                        value={seasonModalItem?.dataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setSeasonModalItem({ ...seasonModalItem, dataKey: e.target.value })}
                                        error={!!seasonErrors.dataKey}
                                        helperText={seasonErrors.dataKey}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={seasonModalItem?.isActive ?? true}
                                                onChange={(e) => setSeasonModalItem({ ...seasonModalItem, isActive: e.target.checked })}
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsSeasonModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleSeasonModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            {isSeasonChanged && (
                                <Button variant="contained" color="primary" onClick={handleSaveSeason}>
                                    💾 Save
                                </Button>
                            )}
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK Application Type</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK Application Type</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddApplicationType} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteApplicationType}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setApplicationTypeList(applicationTypeListBeforeEdit);
                    setIsApplicationTypeChanged(false);
                    applicationTypeGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isApplicationTypeChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeApplicationType(flex)}
                                className="explorer-grid"
                                itemsSource={applicationTypeList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Περιγραφή" binding="description" width="*" />
                                <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                            </FlexGrid>
                            <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} maxWidth="md" fullWidth>
                                <DialogTitle>Edit Application Type</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Id"
                                        type="number"
                                        value={modalItem?.id || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, id: Number(e.target.value) })}
                                        error={!!applicationTypeErrors.id}
                                        helperText={applicationTypeErrors.id}
                                    />

                                    <TextField
                                        label="Description"
                                        value={modalItem?.description || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, description: e.target.value })}
                                        error={!!applicationTypeErrors.description}
                                        helperText={applicationTypeErrors.description}
                                    />

                                    <TextField
                                        label="Abbr"
                                        value={modalItem?.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, abbr: e.target.value })}
                                        error={!!applicationTypeErrors.abbr}
                                        helperText={applicationTypeErrors.abbr}
                                    />

                                    <TextField
                                        label="Hint"
                                        value={modalItem?.hint || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, hint: e.target.value })}
                                    />

                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={modalItem?.position || 0}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, position: Number(e.target.value) })}
                                        error={!!applicationTypeErrors.position}
                                        helperText={applicationTypeErrors.position}
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.concernAthlete || false}
                                                onChange={(e) => setModalItem({ ...modalItem, concernAthlete: e.target.checked })}
                                            />
                                        }
                                        label="Concern Athlete"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.concernOfficial || false}
                                                onChange={(e) => setModalItem({ ...modalItem, concernOfficial: e.target.checked })}
                                            />
                                        }
                                        label="Concern Official"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.concernOrganization || false}
                                                onChange={(e) => setModalItem({ ...modalItem, concernOrganization: e.target.checked })}
                                            />
                                        }
                                        label="Concern Organization"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.isNewAction || false}
                                                onChange={(e) => setModalItem({ ...modalItem, isNewAction: e.target.checked })}
                                            />
                                        }
                                        label="Is New Action"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.isEditAction || false}
                                                onChange={(e) => setModalItem({ ...modalItem, isEditAction: e.target.checked })}
                                            />
                                        }
                                        label="Is Edit Action"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.copyFiles || false}
                                                onChange={(e) => setModalItem({ ...modalItem, copyFiles: e.target.checked })}
                                            />
                                        }
                                        label="Copy Files"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.isActive || false}
                                                onChange={(e) => setModalItem({ ...modalItem, isActive: e.target.checked })}
                                            />
                                        }
                                        label="Active"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={modalItem?.reqKeyB4Submit || false}
                                                onChange={(e) => setModalItem({ ...modalItem, reqKeyB4Submit: e.target.checked })}
                                            />
                                        }
                                        label="Require Key Before Submit"
                                    />

                                    <TextField
                                        label="CopyFiles DataKey"
                                        value={modalItem?.copyFiles_DataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, copyFiles_DataKey: e.target.value })}
                                        error={!!applicationTypeErrors.copyFiles_DataKey}
                                        helperText={applicationTypeErrors.copyFiles_DataKey}
                                    />

                                    <TextField
                                        label="DataKey"
                                        value={modalItem?.dataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, dataKey: e.target.value })}
                                        error={!!applicationTypeErrors.dataKey}
                                        helperText={applicationTypeErrors.dataKey}
                                    />

                                    <TextField
                                        label="Render Options"
                                        value={modalItem?.renderOptions || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setModalItem({ ...modalItem, renderOptions: e.target.value })}
                                        error={!!applicationTypeErrors.renderOptions}
                                        helperText={applicationTypeErrors.renderOptions}
                                    />

                                    <TextField
                                        label="Comments"
                                        value={modalItem?.comments || ''}
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        rows={3}
                                        onChange={(e) => setModalItem({ ...modalItem, comments: e.target.value })}
                                        error={!!applicationTypeErrors.comments}
                                        helperText={applicationTypeErrors.comments}
                                    />
                                </DialogContent>

                                <DialogActions>
                                    <Button onClick={() => setIsModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleApplicationTypeModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            {isApplicationTypeChanged && (
                                <Button variant="contained" color="primary" onClick={handleSaveApplicationType}>
                                    💾 Save
                                </Button>
                            )}
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK Events</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK Events</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddEvent} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteEvent}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEventList(eventListBeforeEdit);
                    setIsEventChanged(false);
                    eventsGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isEventChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeEvents(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={eventList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn
                                    header="Discipline"
                                    binding="disciplineId"
                                    width="*"
                                    dataMap={new wjGrid.DataMap(disciplines, 'id', 'name')}
                                />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Name" binding="name" width="*" />
                                <FlexGridColumn header="Total Athletes" binding="totalAthletes" width="*" />
                                <FlexGridColumn header="Status" binding="isActive" width="*" />
                            </FlexGrid>
                            {isEventChanged && (
                                <Button variant="contained" color="primary" onClick={handleSaveEvent} style={{ marginTop: '10px' }}>
                                    💾 Save
                                </Button>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK Discipline</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddDiscipline} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteDiscipline}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEventList(eventListBeforeEdit);
                    setIsEventChanged(false);
                    eventsGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isEventChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeDiscipline(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={disciplineList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="ID" binding="id" width="*" />
                                <FlexGridColumn
                                    header="Parent"
                                    binding="parentId"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(disciplineParents) ? disciplineParents : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn header="Όνομα" binding="name" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Θέση" binding="position" width="*" />
                                <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                                <FlexGridColumn header="Σχόλια" binding="comments" width="*" />
                            </FlexGrid>
                            {isDisciplineChanged && (
                                <Button variant="contained" color="primary" onClick={handleSaveDiscipline} style={{ marginTop: '10px' }}>
                                    💾 Save
                                </Button>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK AgeCategories</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddAgeCategory} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteAgeCategory}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEventList(eventListBeforeEdit);
                    setIsEventChanged(false);
                    eventsGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isEventChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeAgeCategory(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={ageCategoryList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Code" binding="code" width="*" />
                                <FlexGridColumn header="Όνομα" binding="name" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn
                                    header="Gender"
                                    binding="gender"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            [
                                                { id: 'Θ', name: 'Θύλη' },
                                                { id: 'Α', name: 'Άρρεν' },
                                                { id: 'Χ', name: 'Μεικτό' }
                                            ],
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn header="AgeFrom" binding="ageFrom" width="*" />
                                <FlexGridColumn header="AgeTo" binding="ageTo" width="*" />
                                <FlexGridColumn header="rAgeFrom" binding="rAgeFrom" width="*" />
                                <FlexGridColumn header="rAgeTo" binding="rAgeTo" width="*" />
                                <FlexGridColumn header="Θέση" binding="position" width="*" />
                                <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                            </FlexGrid>
                            {isAgeCategoryChanged && (
                                <Button variant="contained" color="primary" onClick={handleSaveAgeCategory} style={{ marginTop: '10px' }}>
                                    💾 Save
                                </Button>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK Divisions</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddDivision} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteDivision}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEventList(eventListBeforeEdit);
                    setIsEventChanged(false);
                    eventsGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isEventChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeDivision(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={divisionList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn
                                    header="DisciplineId"
                                    binding="disciplineId"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(disciplineList) ? disciplineList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn
                                    header="EventId"
                                    binding="eventId"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(eventList) ? eventList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn
                                    header="Ηλικιακή κατηγορία"
                                    binding="ageCategoryId"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(ageCategoryList) ? ageCategoryList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn
                                    header="Είδος διαγωνισμού"
                                    binding="competitionTypeId"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(competitionTypeList) ? competitionTypeList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn header="Όνομα" binding="name" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Θέση" binding="position" width="*" />
                                <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                            </FlexGrid>
                            {isDivisionChanged && (
                                <Button variant="contained" color="primary" onClick={handleSaveDivision} style={{ marginTop: '10px' }}>
                                    💾 Save
                                </Button>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK CompetitionTypes</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddCompetitionType} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteCompetitionType}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEventList(eventListBeforeEdit);
                    setIsEventChanged(false);
                    eventsGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isEventChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeCompetitionTypes(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={competitionTypeList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Όνομα" binding="name" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Θέση" binding="position" width="*" />
                                <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                                <FlexGridColumn header="Σχόλια" binding="comments" width="*" />
                            </FlexGrid>
                            {isCompetitionTypeChanged && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSaveCompetitionType}
                                    style={{ marginTop: '10px' }}
                                >
                                    💾 Save
                                </Button>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '2rem' }}>
                                <h2>LK EventCategories</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddEventCategory} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteEventCategory}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEventList(eventListBeforeEdit);
                    setIsEventChanged(false);
                    eventsGridRef.current?.collectionView.refresh();
                  }}
                  disabled={!isEventChanged}
                >
                  🔄 Reset
                </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeEventCategory(flex)} // ensure change tracking
                                className="explorer-grid"
                                itemsSource={paginatedEventCategories.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn
                                    header="Γεγονός"
                                    binding="eventId"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(eventList) ? eventList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn
                                    header="Ηλικιακή κατηγορία"
                                    binding="ageCategoryId"
                                    width="*"
                                    dataMap={
                                        new wjGrid.DataMap(
                                            new wijmo.CollectionView(Array.isArray(ageCategoryList) ? ageCategoryList : []),
                                            'id',
                                            'name'
                                        )
                                    }
                                />
                                <FlexGridColumn header="divisionId" binding="divisionId" width="*" />
                                <FlexGridColumn header="additionalDescr" binding="additionalDescr" width="*" />
                                <FlexGridColumn header="distanceFrom" binding="distanceFrom" width="*" />
                                <FlexGridColumn header="distanceTo" binding="distanceTo" width="*" />
                                <FlexGridColumn header="distanceDescr" binding="distanceDescr" width="*" />
                                <FlexGridColumn header="weightFrom" binding="weightFrom" width="*" />
                                <FlexGridColumn header="weightTo" binding="weightTo" width="*" />
                                <FlexGridColumn header="weightDescr" binding="weightDescr" width="*" />
                                <FlexGridColumn header="heightFrom" binding="heightFrom" width="*" />
                                <FlexGridColumn header="heightTo" binding="heightTo" width="*" />
                                <FlexGridColumn header="heightDescr" binding="heightDescr" width="*" />
                                <FlexGridColumn header="Ολυμπιακό" binding="isOlympic" width="*" />
                            </FlexGrid>
                            {!paginationEnded && (
                                <Button variant="contained" color="primary" onClick={next50Items} style={{ marginTop: '10px' }}>
                                    Επόμενα 50 ...
                                </Button>
                            )}
                            {isEventCategoryChanged && (
                                <Button variant="contained" color="primary" onClick={handleSaveEventCategory} style={{ marginTop: '10px' }}>
                                    💾 Save
                                </Button>
                            )}
                            <Dialog open={isEventModalOpen} onClose={() => setIsEventModalOpen(false)} maxWidth="sm" fullWidth>
                                <DialogTitle>Add/Edit Event</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Name"
                                        value={eventModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, name: e.target.value })}
                                        error={!!eventErrors.name}
                                        helperText={eventErrors.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={eventModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, abbr: e.target.value })}
                                        error={!!eventErrors.abbr}
                                        helperText={eventErrors.abbr}
                                    />
                                    <TextField
                                        label="Code"
                                        type="number"
                                        value={eventModalItem.code || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, code: Number(e.target.value) })}
                                        error={!!eventErrors.code}
                                        helperText={eventErrors.code}
                                    />
                                    <FormControl fullWidth margin="normal" error={!!eventErrors.disciplineId}>
                                        <InputLabel id="discipline-label">Discipline</InputLabel>
                                        <Select
                                            labelId="discipline-label"
                                            id="discipline"
                                            value={eventModalItem.disciplineId || ''}
                                            label="Discipline"
                                            onChange={(e) =>
                                                setEventModalItem({
                                                    ...eventModalItem,
                                                    disciplineId: Number(e.target.value)
                                                })
                                            }
                                        >
                                            {disciplines.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {eventErrors.disciplineId && (
                                            <Typography variant="caption" color="error">
                                                {eventErrors.disciplineId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="Total Athletes"
                                        type="number"
                                        value={eventModalItem.totalAthletes || 0}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setEventModalItem({ ...eventModalItem, totalAthletes: Number(e.target.value) })}
                                        error={!!eventErrors.totalAthletes}
                                        helperText={eventErrors.totalAthletes}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={eventModalItem.isActive ?? true}
                                                onChange={(e) => setEventModalItem({ ...eventModalItem, isActive: e.target.checked })}
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsEventModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleEventModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={isDisciplineModalOpen} onClose={() => setIsDisciplineModalOpen(false)} maxWidth="sm" fullWidth>
                                <DialogTitle>Add/Edit Discipline</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Id"
                                        type="number"
                                        value={disciplineModalItem.id || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, id: e.target.value })}
                                        error={!!disciplineErrors.id}
                                        helperText={disciplineErrors.id}
                                    />
                                    <FormControl fullWidth margin="normal" error={!!disciplineErrors.parentId}>
                                        <InputLabel id="parent-label">Parent</InputLabel>
                                        <Select
                                            labelId="parent-label"
                                            id="parent"
                                            value={disciplineModalItem.parentId || ''}
                                            label="Parent"
                                            onChange={(e) =>
                                                setDisciplineModalItem({
                                                    ...disciplineModalItem,
                                                    parentId: Number(e.target.value)
                                                })
                                            }
                                        >
                                            {Array.isArray(disciplineParents) && disciplineParents.length > 0 ? (
                                                disciplineParents.map((d) => (
                                                    <MenuItem key={d.id} value={d.id}>
                                                        {d.name}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>No children</MenuItem>
                                            )}
                                        </Select>
                                        {disciplineErrors.parentId && (
                                            <Typography variant="caption" color="error">
                                                {disciplineErrors.parentId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="Description"
                                        value={disciplineModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, name: e.target.value })}
                                        error={!!disciplineErrors.name}
                                        helperText={disciplineErrors.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={disciplineModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, abbr: e.target.value })}
                                        error={!!disciplineErrors.abbr}
                                        helperText={disciplineErrors.abbr}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={disciplineModalItem.position || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setDisciplineModalItem({ ...disciplineModalItem, position: Number(e.target.value) })
                                        }
                                        error={!!disciplineErrors.position}
                                        helperText={disciplineErrors.position}
                                    />
                                    <TextField
                                        label="Comments"
                                        value={disciplineModalItem.comments || ''}
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        onChange={(e) => setDisciplineModalItem({ ...disciplineModalItem, comments: e.target.value })}
                                        error={!!disciplineErrors.comments}
                                        helperText={disciplineErrors.comments}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={disciplineModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setDisciplineModalItem({ ...disciplineModalItem, isActive: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsDisciplineModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleDisciplineModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={isAgeCategoryModalOpen} onClose={() => setIsAgeCategoryModalOpen(false)} maxWidth="sm" fullWidth>
                                <DialogTitle>Add/Edit Age Category</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Name"
                                        value={AgeCategoryModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setAgeCategoryModalItem({ ...AgeCategoryModalItem, name: e.target.value })}
                                        error={!!ageCategoryErrors.name}
                                        helperText={ageCategoryErrors.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={AgeCategoryModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setAgeCategoryModalItem({ ...AgeCategoryModalItem, abbr: e.target.value })}
                                        error={!!ageCategoryErrors.abbr}
                                        helperText={ageCategoryErrors.abbr}
                                    />
                                    <TextField
                                        label="Code"
                                        type="number"
                                        value={AgeCategoryModalItem.code || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setAgeCategoryModalItem({ ...AgeCategoryModalItem, code: Number(e.target.value) })}
                                        error={!!ageCategoryErrors.code}
                                        helperText={ageCategoryErrors.code}
                                    />
                                    <FormControl fullWidth margin="normal" error={!!ageCategoryErrors.gender}>
                                        <InputLabel id="gender-label">Gender</InputLabel>
                                        <Select
                                            labelId="gender-label"
                                            id="gender"
                                            value={AgeCategoryModalItem.gender || ''}
                                            label="Gender"
                                            onChange={(e) =>
                                                setAgeCategoryModalItem({
                                                    ...AgeCategoryModalItem,
                                                    gender: e.target.value
                                                })
                                            }
                                        >
                                            {[
                                                { id: 'Θ', name: 'Θύλη' },
                                                { id: 'Α', name: 'Άρρεν' },
                                                { id: 'Χ', name: 'Μεικτό' }
                                            ].map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {ageCategoryErrors.gender && (
                                            <Typography variant="caption" color="error">
                                                {ageCategoryErrors.gender}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="AgeFrom"
                                        type="number"
                                        value={AgeCategoryModalItem.ageFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({ ...AgeCategoryModalItem, ageFrom: Number(e.target.value) })
                                        }
                                        error={!!ageCategoryErrors.ageFrom}
                                        helperText={ageCategoryErrors.ageFrom}
                                    />
                                    <TextField
                                        label="AgeTo"
                                        type="number"
                                        value={AgeCategoryModalItem.ageTo || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({ ...AgeCategoryModalItem, ageTo: Number(e.target.value) })
                                        }
                                        error={!!ageCategoryErrors.ageTo}
                                        helperText={ageCategoryErrors.ageTo}
                                    />
                                    <TextField
                                        label="RageFrom"
                                        type="number"
                                        value={AgeCategoryModalItem.rAgeFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({ ...AgeCategoryModalItem, rAgeFrom: Number(e.target.value) })
                                        }
                                        error={!!ageCategoryErrors.rAgeFrom}
                                        helperText={ageCategoryErrors.rAgeFrom}
                                    />
                                    <TextField
                                        label="RageTo"
                                        type="number"
                                        value={AgeCategoryModalItem.rAgeTo || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({ ...AgeCategoryModalItem, rAgeTo: Number(e.target.value) })
                                        }
                                        error={!!ageCategoryErrors.rAgeTo}
                                        helperText={ageCategoryErrors.rAgeTo}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={AgeCategoryModalItem.position || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAgeCategoryModalItem({ ...AgeCategoryModalItem, position: Number(e.target.value) })
                                        }
                                        error={!!ageCategoryErrors.position}
                                        helperText={ageCategoryErrors.position}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={AgeCategoryModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setAgeCategoryModalItem({ ...AgeCategoryModalItem, isActive: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsAgeCategoryModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleAgeCategoryModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={isDivisionModalOpen} onClose={() => setIsDivisionModalOpen(false)} maxWidth="sm" fullWidth>
                                <DialogTitle>Add/Edit Divisions</DialogTitle>
                                <DialogContent dividers>
                                    <FormControl fullWidth margin="normal" error={!!divisionErrors.disciplineId}>
                                        <InputLabel id="disciplineId-label">DisciplineId</InputLabel>
                                        <Select
                                            labelId="disciplineId-label"
                                            id="disciplineId"
                                            value={DivisionModalItem.disciplineId || ''}
                                            label="DisciplineId"
                                            onChange={(e) =>
                                                setDivisionModalItem({
                                                    ...DivisionModalItem,
                                                    disciplineId: e.target.value
                                                })
                                            }
                                        >
                                            {disciplineList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {divisionErrors.disciplineId && (
                                            <Typography variant="caption" color="error">
                                                {divisionErrors.disciplineId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!divisionErrors.eventId}>
                                        <InputLabel id="eventId-label">EventId</InputLabel>
                                        <Select
                                            labelId="eventId-label"
                                            id="eventId"
                                            value={DivisionModalItem.eventId || ''}
                                            label="EventId"
                                            onChange={(e) =>
                                                setDivisionModalItem({
                                                    ...DivisionModalItem,
                                                    eventId: e.target.value
                                                })
                                            }
                                        >
                                            {eventList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {divisionErrors.eventId && (
                                            <Typography variant="caption" color="error">
                                                {divisionErrors.eventId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!divisionErrors.ageCategoryId}>
                                        <InputLabel id="ageCategoryId-label">AgeCategoryId</InputLabel>
                                        <Select
                                            labelId="ageCategoryId-label"
                                            id="ageCategoryId"
                                            value={DivisionModalItem.ageCategoryId || ''}
                                            label="AgeCategoryId"
                                            onChange={(e) =>
                                                setDivisionModalItem({
                                                    ...DivisionModalItem,
                                                    ageCategoryId: e.target.value
                                                })
                                            }
                                        >
                                            {ageCategoryList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {divisionErrors.ageCategoryId && (
                                            <Typography variant="caption" color="error">
                                                {divisionErrors.ageCategoryId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!divisionErrors.competitionTypeId}>
                                        <InputLabel id="competitionTypeId-label">CompetitionTypeId</InputLabel>
                                        <Select
                                            labelId="competitionTypeId-label"
                                            id="competitionTypeId"
                                            value={DivisionModalItem.competitionTypeId || ''}
                                            label="CompetitionTypeId"
                                            onChange={(e) =>
                                                setDivisionModalItem({
                                                    ...DivisionModalItem,
                                                    competitionTypeId: e.target.value
                                                })
                                            }
                                        >
                                            {competitionTypeList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {divisionErrors.competitionTypeId && (
                                            <Typography variant="caption" color="error">
                                                {divisionErrors.competitionTypeId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="Name"
                                        value={DivisionModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDivisionModalItem({ ...DivisionModalItem, name: e.target.value })}
                                        error={!!divisionErrors.name}
                                        helperText={divisionErrors.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={DivisionModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setDivisionModalItem({ ...DivisionModalItem, abbr: e.target.value })}
                                        error={!!divisionErrors.abbr}
                                        helperText={divisionErrors.abbr}
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsDivisionModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleDivisionModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={isCompetitionTypeModalOpen}
                                onClose={() => setIsCompetitionTypeModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit CompetitionType</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Description"
                                        value={CompetitionTypeModalItem.name || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, name: e.target.value })}
                                        error={!!competitionTypeErrors.name}
                                        helperText={competitionTypeDataQuery.name}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={CompetitionTypeModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, abbr: e.target.value })}
                                        error={!!competitionTypeDataQuery.abbr}
                                        helperText={competitionTypeDataQuery.abbr}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={CompetitionTypeModalItem.position || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, position: Number(e.target.value) })
                                        }
                                        error={!!competitionTypeErrors.position}
                                        helperText={competitionTypeErrors.position}
                                    />
                                    <TextField
                                        label="Comments"
                                        value={CompetitionTypeModalItem.comments || ''}
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        onChange={(e) =>
                                            setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, comments: e.target.value })
                                        }
                                        error={!!competitionTypeErrors.comments}
                                        helperText={competitionTypeErrors.comments}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={CompetitionTypeModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setCompetitionTypeModalItem({ ...CompetitionTypeModalItem, isActive: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsCompetitionTypeModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleCompetitionTypeModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={isEventCategoryModalOpen}
                                onClose={() => setIsEventCategoryModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit Event Category</DialogTitle>
                                <DialogContent dividers>
                                    <FormControl fullWidth margin="normal" error={!!eventCategoryErrors.eventId}>
                                        <InputLabel id="eventId-label">EventId</InputLabel>
                                        <Select
                                            labelId="eventId-label"
                                            id="eventId"
                                            value={EventCategoryModalItem.eventId || ''}
                                            label="EventId"
                                            onChange={(e) =>
                                                setEventCategoryModalItem({
                                                    ...EventCategoryModalItem,
                                                    eventId: Number(e.target.value)
                                                })
                                            }
                                        >
                                            {eventList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {eventCategoryErrors.eventId && (
                                            <Typography variant="caption" color="error">
                                                {eventCategoryErrors.eventId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!eventCategoryErrors.ageCategoryId}>
                                        <InputLabel id="ageCategoryId-label">AgeCategoryId</InputLabel>
                                        <Select
                                            labelId="ageCategoryId-label"
                                            id="ageCategoryId"
                                            value={EventCategoryModalItem.ageCategoryId || ''}
                                            label="AgeCategoryId"
                                            onChange={(e) =>
                                                setEventCategoryModalItem({
                                                    ...EventCategoryModalItem,
                                                    ageCategoryId: Number(e.target.value)
                                                })
                                            }
                                        >
                                            {ageCategoryList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {eventCategoryErrors.ageCategoryId && (
                                            <Typography variant="caption" color="error">
                                                {eventCategoryErrors.ageCategoryId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" error={!!eventCategoryErrors.divisionId}>
                                        <InputLabel id="divisionId-label">DivisionId</InputLabel>
                                        <Select
                                            labelId="divisionId-label"
                                            id="divisionId"
                                            value={EventCategoryModalItem.divisionId || ''}
                                            label="DivisionId"
                                            onChange={(e) =>
                                                setEventCategoryModalItem({
                                                    ...EventCategoryModalItem,
                                                    divisionId: Number(e.target.value)
                                                })
                                            }
                                        >
                                            {divisionList.map((d) => (
                                                <MenuItem key={d.id} value={d.id}>
                                                    {d.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {eventCategoryErrors.divisionId && (
                                            <Typography variant="caption" color="error">
                                                {eventCategoryErrors.divisionId}
                                            </Typography>
                                        )}
                                    </FormControl>
                                    <TextField
                                        label="Περιγραφή"
                                        value={EventCategoryModalItem.additionalDescr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, additionalDescr: e.target.value })
                                        }
                                        error={!!eventCategoryErrors.additionalDescr}
                                        helperText={eventCategoryErrors.additionalDescr}
                                    />
                                    <TextField
                                        label="DistanceFrom"
                                        type="number"
                                        value={EventCategoryModalItem.distanceFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, distanceFrom: Number(e.target.value) })
                                        }
                                        error={!!eventCategoryErrors.distanceFrom}
                                        helperText={eventCategoryErrors.distanceFrom}
                                    />
                                    <TextField
                                        label="DistanceTo"
                                        type="number"
                                        value={EventCategoryModalItem.distanceTo || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, distanceTo: Number(e.target.value) })
                                        }
                                        error={!!ageCategoryErrors.distanceTo}
                                        helperText={ageCategoryErrors.distanceTo}
                                    />
                                    <TextField
                                        label="DistanceDescr"
                                        value={EventCategoryModalItem.distanceDescr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, distanceDescr: e.target.value })
                                        }
                                        error={!!eventCategoryErrors.distanceDescr}
                                        helperText={eventCategoryErrors.distanceDescr}
                                    />
                                    <TextField
                                        label="WeightFrom"
                                        type="number"
                                        value={EventCategoryModalItem.weightFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, weightFrom: Number(e.target.value) })
                                        }
                                        error={!!eventCategoryErrors.weightFrom}
                                        helperText={eventCategoryErrors.weightFrom}
                                    />
                                    <TextField
                                        label="WeightTo"
                                        type="number"
                                        value={EventCategoryModalItem.weightTo || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, weightTo: Number(e.target.value) })
                                        }
                                        error={!!eventCategoryErrors.weightTo}
                                        helperText={eventCategoryErrors.weightTo}
                                    />
                                    <TextField
                                        label="WeightDescr"
                                        value={EventCategoryModalItem.weightDescr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, weightDescr: e.target.value })
                                        }
                                        error={!!eventCategoryErrors.weightDescr}
                                        helperText={eventCategoryErrors.weightDescr}
                                    />
                                    <TextField
                                        label="HeightFrom"
                                        type="number"
                                        value={EventCategoryModalItem.heightFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, heightFrom: Number(e.target.value) })
                                        }
                                        error={!!eventCategoryErrors.heightFrom}
                                        helperText={eventCategoryErrors.heightFrom}
                                    />
                                    <TextField
                                        label="HeightTo"
                                        type="number"
                                        value={EventCategoryModalItem.heightTo || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, heightTo: Number(e.target.value) })
                                        }
                                        error={!!eventCategoryErrors.heightTo}
                                        helperText={eventCategoryErrors.heightTo}
                                    />
                                    <TextField
                                        label="HeightDescr"
                                        value={EventCategoryModalItem.heightDescr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setEventCategoryModalItem({ ...EventCategoryModalItem, heightDescr: e.target.value })
                                        }
                                        error={!!eventCategoryErrors.heightDescr}
                                        helperText={eventCategoryErrors.heightDescr}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={EventCategoryModalItem.isOlympic ?? true}
                                                onChange={(e) =>
                                                    setEventCategoryModalItem({ ...EventCategoryModalItem, isOlympic: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Ολυμπιακό"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsEventCategoryModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleEventCategoryModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">Application Type Product Ages</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div>
                                <h2>Application Type Product Ages</h2>
                                <FlexGrid
                                    initialized={(flex) => initializeApplicationTypeProductAges(flex)}
                                    className="explorer-grid"
                                    itemsSource={applicationTypeProductAgesDataQuery?.data}
                                    autoSizeMode={1}
                                    headersVisibility={3}
                                    alternatingRowStep={0}
                                >
                                    <FlexGridColumn header="Ενότητα / Περιγραφή" binding="productDescription" width="*" isReadOnly={true} />
                                    <FlexGridColumn header="Από Ηλικία" binding="fromAge" width="*" />
                                    <FlexGridColumn header="Έως Ηλικία" binding="toAge" width="*" />
                                    <FlexGridColumn header="Τιμή" binding="unitPrice" width="*" />
                                    <FlexGridColumn header="Έγκυρο από" binding="validFrom" width="*" />
                                    <FlexGridColumn header="Έγκυρο έως" binding="validTo" width="*" />
                                    <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                                </FlexGrid>
                                {isApplicationTypeProductAgesChanged && (
                                    <Button variant="contained" color="primary" onClick={handleApplicationTypeProductAges}>
                                        Save
                                    </Button>
                                )}
                            </div>
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">Application Type Product Services</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>Application Type Product Services</h2>
                                <div>
                                    <Button
                                        variant="outlined"
                                        onClick={handleAddApplicationTypeProductService}
                                        style={{ marginRight: '10px' }}
                                    >
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteApplicationTypeProductService}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  const restored = JSON.parse(JSON.stringify(lastCommittedApplicationTypeProductServices));
                  setApplicationTypeProductServicesList(restored);
                  setIsApplicationTypeProductServicesChanged(false);
                  applicationTypeProductServicesGridRef.current?.collectionView.refresh();
                }}
                disabled={!isApplicationTypeProductServicesChanged}
              >
                🔄 Reset
              </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeApplicationTypeProductServices(flex)}
                                className="explorer-grid"
                                itemsSource={applicationTypeProductServicesList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Application Type" binding="applicationTypeTitle" width="*" isReadOnly={true} />
                                <FlexGridColumn header="Product Service" binding="productServiceTitle" width="*" isReadOnly={true} />
                                <FlexGridColumn header="Unit Price" binding="unitPrice" width="*" />
                                <FlexGridColumn header="VAT %" binding="vatPerc" width="*" />
                                <FlexGridColumn header="Valid From" binding="validFrom" width="*" />
                                <FlexGridColumn header="Valid To" binding="validTo" width="*" />
                                <FlexGridColumn header="Trans Type" binding="transTypeId" width="*" />
                                <FlexGridColumn header="Status" binding="isActive" width="*" />
                            </FlexGrid>
                            <Dialog
                                open={isAppTypeProductServicesModalOpen}
                                onClose={() => setIsAppTypeProductServicesModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit Application Type Product Service</DialogTitle>
                                <DialogContent dividers>
                                    <FormControl fullWidth margin="normal" error={!!appTypeProductServicesErrors.applicationTypeId}>
                                        <InputLabel id="app-type-label">Application Type</InputLabel>
                                        <Select
                                            labelId="app-type-label"
                                            value={appTypeProductServicesModalItem.applicationTypeId || ''}
                                            onChange={(e) =>
                                                setAppTypeProductServicesModalItem({
                                                    ...appTypeProductServicesModalItem,
                                                    applicationTypeId: e.target.value
                                                })
                                            }
                                        >
                                            {applicationTypeList.map((type) => (
                                                <MenuItem key={type.id} value={type.id}>
                                                    {type.description || type.abbr}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {appTypeProductServicesErrors.applicationTypeId && (
                                            <Typography variant="caption" color="error">
                                                {appTypeProductServicesErrors.applicationTypeId}
                                            </Typography>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth margin="normal" error={!!appTypeProductServicesErrors.productServiceId}>
                                        <InputLabel id="product-service-label">Product Service</InputLabel>
                                        <Select
                                            labelId="product-service-label"
                                            value={appTypeProductServicesModalItem.productServiceId || ''}
                                            onChange={(e) =>
                                                setAppTypeProductServicesModalItem({
                                                    ...appTypeProductServicesModalItem,
                                                    productServiceId: e.target.value
                                                })
                                            }
                                        >
                                            {productServicesList.map((ps) => (
                                                <MenuItem key={ps.id} value={ps.id}>
                                                    {ps.description || ps.code}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {appTypeProductServicesErrors.productServiceId && (
                                            <Typography variant="caption" color="error">
                                                {appTypeProductServicesErrors.productServiceId}
                                            </Typography>
                                        )}
                                    </FormControl>

                                    <TextField
                                        label="Unit Price"
                                        type="number"
                                        value={appTypeProductServicesModalItem.unitPrice || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAppTypeProductServicesModalItem({
                                                ...appTypeProductServicesModalItem,
                                                unitPrice: parseFloat(e.target.value)
                                            })
                                        }
                                        error={!!appTypeProductServicesErrors.unitPrice}
                                        helperText={appTypeProductServicesErrors.unitPrice}
                                    />

                                    <TextField
                                        label="VAT %"
                                        type="number"
                                        value={appTypeProductServicesModalItem.vatPerc || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setAppTypeProductServicesModalItem({
                                                ...appTypeProductServicesModalItem,
                                                vatPerc: parseFloat(e.target.value)
                                            })
                                        }
                                        error={!!appTypeProductServicesErrors.vatPerc}
                                        helperText={appTypeProductServicesErrors.vatPerc}
                                    />

                                    <TextField
                                        label="Valid From"
                                        type="date"
                                        value={appTypeProductServicesModalItem.validFrom || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) =>
                                            setAppTypeProductServicesModalItem({
                                                ...appTypeProductServicesModalItem,
                                                validFrom: e.target.value
                                            })
                                        }
                                    />

                                    <TextField
                                        label="Valid To"
                                        type="date"
                                        value={appTypeProductServicesModalItem.validTo || ''}
                                        fullWidth
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) =>
                                            setAppTypeProductServicesModalItem({
                                                ...appTypeProductServicesModalItem,
                                                validTo: e.target.value
                                            })
                                        }
                                        error={!!appTypeProductServicesErrors.validTo}
                                        helperText={appTypeProductServicesErrors.validTo}
                                    />

                                    <FormControl fullWidth margin="normal" error={!!appTypeProductServicesErrors.transTypeId}>
                                        <InputLabel id="trans-type-label">Transaction Type</InputLabel>
                                        <Select
                                            labelId="trans-type-label"
                                            value={appTypeProductServicesModalItem.transTypeId || ''}
                                            onChange={(e) =>
                                                setAppTypeProductServicesModalItem({
                                                    ...appTypeProductServicesModalItem,
                                                    transTypeId: e.target.value
                                                })
                                            }
                                        >
                                            {transactionTypesList.map((t) => (
                                                <MenuItem key={t.id} value={t.id}>
                                                    {t.description || t.abbr || 'Unnamed'}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {appTypeProductServicesErrors.transTypeId && (
                                            <Typography variant="caption" color="error">
                                                {appTypeProductServicesErrors.transTypeId}
                                            </Typography>
                                        )}
                                    </FormControl>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={appTypeProductServicesModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setAppTypeProductServicesModalItem({
                                                        ...appTypeProductServicesModalItem,
                                                        isActive: e.target.checked
                                                    })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>

                                <DialogActions>
                                    <Button onClick={() => setIsAppTypeProductServicesModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleApplicationTypeProductServiceModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            {isApplicationTypeProductServicesChanged && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSaveApplicationTypeProductServices}
                                    style={{ marginTop: '10px' }}
                                >
                                    💾 Save
                                </Button>
                            )}
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">Product Services</Typography>}
                    content={
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>Product Services</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddProductService} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteProductService}>
                                        🗑️ Delete
                                    </Button>
                                </div>
                            </div>

                            <FlexGrid
                                initialized={(flex) => initializeProductServices(flex)}
                                className="explorer-grid"
                                itemsSource={productServicesList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Description" binding="description" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Code" binding="code" width="*" />
                                <FlexGridColumn header="Unit Price" binding="unitPrice" width="*" />
                                <FlexGridColumn header="VAT %" binding="vatPerc" width="*" />
                                <FlexGridColumn header="Position" binding="position" width="*" />
                                <FlexGridColumn header="Active" binding="isActive" width="*" />
                                <FlexGridColumn header="Unique Per Entity" binding="isUniquePerEntity" width="*" />
                            </FlexGrid>

                            <Dialog
                                open={isProductServicesModalOpen}
                                onClose={() => setIsProductServicesModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit Product Service</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Description"
                                        value={productServicesModalItem.description || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setProductServicesModalItem({ ...productServicesModalItem, description: e.target.value })
                                        }
                                        error={!!productServicesErrors.description}
                                        helperText={productServicesErrors.description}
                                    />

                                    <TextField
                                        label="Abbreviation"
                                        value={productServicesModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setProductServicesModalItem({ ...productServicesModalItem, abbr: e.target.value })}
                                        error={!!productServicesErrors.abbr}
                                        helperText={productServicesErrors.abbr}
                                    />

                                    <TextField
                                        label="Code"
                                        value={productServicesModalItem.code || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setProductServicesModalItem({ ...productServicesModalItem, code: e.target.value })}
                                    />

                                    <TextField
                                        label="Unit Price"
                                        type="number"
                                        value={productServicesModalItem.unitPrice || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setProductServicesModalItem({
                                                ...productServicesModalItem,
                                                unitPrice: parseFloat(e.target.value)
                                            })
                                        }
                                        error={!!productServicesErrors.unitPrice}
                                        helperText={productServicesErrors.unitPrice}
                                    />

                                    <TextField
                                        label="VAT %"
                                        type="number"
                                        value={productServicesModalItem.vatPerc || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setProductServicesModalItem({
                                                ...productServicesModalItem,
                                                vatPerc: parseFloat(e.target.value)
                                            })
                                        }
                                        error={!!productServicesErrors.vatPerc}
                                        helperText={productServicesErrors.vatPerc}
                                    />

                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={productServicesModalItem.position || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) =>
                                            setProductServicesModalItem({ ...productServicesModalItem, position: parseInt(e.target.value) })
                                        }
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={productServicesModalItem.isActive ?? true}
                                                onChange={(e) =>
                                                    setProductServicesModalItem({ ...productServicesModalItem, isActive: e.target.checked })
                                                }
                                            />
                                        }
                                        label="Active"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={productServicesModalItem.isUniquePerEntity ?? false}
                                                onChange={(e) =>
                                                    setProductServicesModalItem({
                                                        ...productServicesModalItem,
                                                        isUniquePerEntity: e.target.checked
                                                    })
                                                }
                                            />
                                        }
                                        label="Unique Per Entity"
                                    />
                                </DialogContent>

                                <DialogActions>
                                    <Button onClick={() => setIsProductServicesModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleProductServicesModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            {isProductServicesChanged && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSaveProductServices}
                                    style={{ marginTop: '10px' }}
                                >
                                    💾 Save
                                </Button>
                            )}
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK File Types</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK File Types</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddFileType} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteFileType}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setFileTypesList(fileTypesBeforeEdit);
                  setIsFileTypesChanged(false);
                  fileTypesGridRef.current?.collectionView.refresh();
                }}
                disabled={!isFileTypesChanged}
              >
                🔄 Reset
              </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={(flex) => initializeFileTypes(flex)}
                                className="explorer-grid"
                                itemsSource={fileTypesList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Code" binding="code" width="*" />
                                <FlexGridColumn header="Description" binding="descr" width="*" />
                                <FlexGridColumn header="Abbr" binding="abbr" width="*" />
                                <FlexGridColumn header="Issued By" binding="lblIssuedBy" width="*" />
                                <FlexGridColumn header="Comments" binding="lblComments" width="*" />
                                <FlexGridColumn header="Status" binding="isActive" width="*" />
                            </FlexGrid>
                            <Dialog open={isFileTypeModalOpen} onClose={() => setIsFileTypeModalOpen(false)} maxWidth="md" fullWidth>
                                <DialogTitle>Add/Edit File Type</DialogTitle>
                                <DialogContent dividers>
                                    <TextField
                                        label="Code"
                                        value={fileTypeModalItem.code || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, code: e.target.value })}
                                        error={!!fileTypesErrors.code}
                                        helperText={fileTypesErrors.code}
                                    />
                                    <TextField
                                        label="Descr"
                                        value={fileTypeModalItem.descr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, descr: e.target.value })}
                                        error={!!fileTypesErrors.descr}
                                        helperText={fileTypesErrors.descr}
                                    />
                                    <TextField
                                        label="Abbr"
                                        value={fileTypeModalItem.abbr || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, abbr: e.target.value })}
                                        error={!!fileTypesErrors.abbr}
                                        helperText={fileTypesErrors.abbr}
                                    />
                                    <TextField
                                        label="DataKey"
                                        value={fileTypeModalItem.dataKey || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, dataKey: e.target.value })}
                                        error={!!fileTypesErrors.dataKey}
                                        helperText={fileTypesErrors.dataKey}
                                    />
                                    <TextField
                                        label="TableRef"
                                        value={fileTypeModalItem.tableRef || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, tableRef: e.target.value })}
                                        error={!!fileTypesErrors.tableRef}
                                        helperText={fileTypesErrors.tableRef}
                                    />
                                    <TextField
                                        label="Position"
                                        type="number"
                                        value={fileTypeModalItem.position || 1}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, position: Number(e.target.value) })}
                                        error={!!fileTypesErrors.position}
                                        helperText={fileTypesErrors.position}
                                    />
                                    <TextField
                                        label="Lbl Issued By"
                                        value={fileTypeModalItem.lblIssuedBy || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, lblIssuedBy: e.target.value })}
                                        error={!!fileTypesErrors.lblIssuedBy}
                                        helperText={fileTypesErrors.lblIssuedBy}
                                    />
                                    <TextField
                                        label="Lbl Comments"
                                        value={fileTypeModalItem.lblComments || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, lblComments: e.target.value })}
                                        error={!!fileTypesErrors.lblComments}
                                        helperText={fileTypesErrors.lblComments}
                                    />
                                    <TextField
                                        label="Templates"
                                        value={fileTypeModalItem.templates || ''}
                                        fullWidth
                                        margin="normal"
                                        onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, templates: e.target.value })}
                                        error={!!fileTypesErrors.templates}
                                        helperText={fileTypesErrors.templates}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={fileTypeModalItem.copyToPF ?? false}
                                                onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, copyToPF: e.target.checked })}
                                            />
                                        }
                                        label="Copy To PF"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={fileTypeModalItem.isActive ?? true}
                                                onChange={(e) => setFileTypeModalItem({ ...fileTypeModalItem, isActive: e.target.checked })}
                                            />
                                        }
                                        label="Active"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setIsFileTypeModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleFileTypeModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            {isFileTypesChanged && (
                                <Button variant="contained" color="primary" onClick={handleSaveFileTypes} style={{ marginTop: '10px' }}>
                                    💾 Save
                                </Button>
                            )}
                        </>
                    }
                />

                <SimpleAccordion
                    title={<Typography variant="h6">LK Optional Answers</Typography>}
                    content={
                        <>
                            {' '}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h2>LK Optional Answers</h2>
                                <div>
                                    <Button variant="outlined" onClick={handleAddOptionalAnswer} style={{ marginRight: '10px' }}>
                                        ➕ Add
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleDeleteOptionalAnswer}>
                                        🗑️ Delete
                                    </Button>
                                    {/* <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              setOptionalAnswersList(optionalAnswersBeforeEdit);
              setIsOptionalAnswerChanged(false);
              setHasCapturedOptionalAnswerSnapshot(false); // clear snapshot after reset
              optionalAnswersGridRef.current?.collectionView.refresh();
            }}
            disabled={!isOptionalAnswerChanged}
          >
            🔄 Reset
          </Button> */}
                                </div>
                            </div>
                            <FlexGrid
                                initialized={initializeOptionalAnswers}
                                className="explorer-grid"
                                itemsSource={optionalAnswersList.filter((item) => !item.isDeleted)}
                                autoSizeMode={1}
                                headersVisibility={3}
                                alternatingRowStep={0}
                            >
                                <FlexGridColumn header="Question" binding="questionTitle" width="*" isReadOnly={true} />
                                <FlexGridColumn header="Title" binding="title" width="*" />
                                <FlexGridColumn header="Correct" binding="isCorrect" width="*" />
                                <FlexGridColumn header="Position" binding="position" width="*" />
                                <FlexGridColumn header="Active" binding="isActive" width="*" />
                                <FlexGridColumn header="Disabled" binding="isDisabled" width="*" />
                            </FlexGrid>
                            <Dialog
                                open={isOptionalAnswerModalOpen}
                                onClose={() => setIsOptionalAnswerModalOpen(false)}
                                maxWidth="sm"
                                fullWidth
                            >
                                <DialogTitle>Add/Edit Optional Answer</DialogTitle>
                                <DialogContent dividers>
                                    {optionalAnswerModalItem && (
                                        <>
                                            <FormControl fullWidth margin="normal" error={!!optionalAnswerErrors.questionId}>
                                                <InputLabel id="question-id-label">Question</InputLabel>
                                                <Select
                                                    labelId="question-id-label"
                                                    id="question-id"
                                                    value={optionalAnswerModalItem.questionId || ''}
                                                    label="Question"
                                                    onChange={(e) =>
                                                        setOptionalAnswerModalItem({
                                                            ...optionalAnswerModalItem,
                                                            questionId: e.target.value
                                                        })
                                                    }
                                                >
                                                    {questionList
                                                        .filter((q) => !q.isDeleted)
                                                        .map((q) => (
                                                            <MenuItem key={q.id} value={q.id}>
                                                                {q.title || q.code || 'Untitled'}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                                {optionalAnswerErrors.questionId && (
                                                    <Typography variant="caption" color="error">
                                                        {optionalAnswerErrors.questionId}
                                                    </Typography>
                                                )}
                                            </FormControl>

                                            <TextField
                                                label="Title"
                                                fullWidth
                                                margin="normal"
                                                value={optionalAnswerModalItem.title || ''}
                                                onChange={(e) =>
                                                    setOptionalAnswerModalItem({ ...optionalAnswerModalItem, title: e.target.value })
                                                }
                                                error={!!optionalAnswerErrors.title}
                                                helperText={optionalAnswerErrors.title}
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={optionalAnswerModalItem.isCorrect ?? false}
                                                        onChange={(e) =>
                                                            setOptionalAnswerModalItem({
                                                                ...optionalAnswerModalItem,
                                                                isCorrect: e.target.checked
                                                            })
                                                        }
                                                    />
                                                }
                                                label="Is Correct"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={optionalAnswerModalItem.isActive ?? true}
                                                        onChange={(e) =>
                                                            setOptionalAnswerModalItem({
                                                                ...optionalAnswerModalItem,
                                                                isActive: e.target.checked
                                                            })
                                                        }
                                                    />
                                                }
                                                label="Active"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={optionalAnswerModalItem.isDisabled ?? false}
                                                        onChange={(e) =>
                                                            setOptionalAnswerModalItem({
                                                                ...optionalAnswerModalItem,
                                                                isDisabled: e.target.checked
                                                            })
                                                        }
                                                    />
                                                }
                                                label="Disabled"
                                            />

                                            <TextField
                                                label="Position"
                                                type="number"
                                                fullWidth
                                                margin="normal"
                                                value={optionalAnswerModalItem.position ?? 0}
                                                onChange={(e) =>
                                                    setOptionalAnswerModalItem({
                                                        ...optionalAnswerModalItem,
                                                        position: Number(e.target.value)
                                                    })
                                                }
                                                error={!!optionalAnswerErrors.position}
                                                helperText={optionalAnswerErrors.position}
                                            />

                                            <TextField
                                                label="Optional Answer Code 1"
                                                fullWidth
                                                margin="normal"
                                                value={optionalAnswerModalItem.optionalAnswerCode1 || ''}
                                                onChange={(e) =>
                                                    setOptionalAnswerModalItem({
                                                        ...optionalAnswerModalItem,
                                                        optionalAnswerCode1: e.target.value
                                                    })
                                                }
                                                error={!!optionalAnswerErrors.optionalAnswerCode1}
                                                helperText={optionalAnswerErrors.optionalAnswerCode1}
                                            />

                                            <TextField
                                                label="Optional Answer Code 2"
                                                fullWidth
                                                margin="normal"
                                                value={optionalAnswerModalItem.optionalAnswerCode2 || ''}
                                                onChange={(e) =>
                                                    setOptionalAnswerModalItem({
                                                        ...optionalAnswerModalItem,
                                                        optionalAnswerCode2: e.target.value
                                                    })
                                                }
                                                error={!!optionalAnswerErrors.optionalAnswerCode2}
                                                helperText={optionalAnswerErrors.optionalAnswerCode2}
                                            />
                                        </>
                                    )}
                                </DialogContent>

                                <DialogActions>
                                    <Button onClick={() => setIsOptionalAnswerModalOpen(false)}>Cancel</Button>
                                    <Button variant="contained" onClick={handleOptionalAnswerModalSave}>
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            {isOptionalAnswerChanged && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSaveOptionalAnswers}
                                    style={{ marginTop: '10px' }}
                                >
                                    💾 Save
                                </Button>
                            )}
                        </>
                    }
                />

                <div>
                    <SimpleAccordion
                        title={<Typography variant="h6">LK Question</Typography>}
                        content={
                            <>
                                {' '}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}></div>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}
                                >
                                    <h2 style={{ margin: 0 }}>LK Question</h2>
                                    <div>
                                        <Button variant="outlined" onClick={handleAddQuestion} style={{ marginRight: '20px' }}>
                                            ➕ Add
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleDeleteQuestion}>
                                            🗑️ Delete
                                        </Button>
                                        {/* <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setQuestionList(questionListBeforeEdit);
                        setIsQuestionChanged(false);
                        setHasCapturedQuestionSnapshot(false);
                        questionsGridRef.current?.collectionView.refresh();
                      }}
                      disabled={!isQuestionChanged}
                    >
                      🔄 Reset
                    </Button> */}
                                    </div>
                                </div>
                                <FlexGrid
                                    initialized={initializeQuestions}
                                    className="explorer-grid"
                                    itemsSource={questionList.filter((q) => !q.isDeleted)}
                                    autoSizeMode={1}
                                    headersVisibility={3}
                                    alternatingRowStep={0}
                                >
                                    <FlexGridColumn header="Code" binding="code" width="*" />
                                    <FlexGridColumn header="Title" binding="title" width="*" />
                                    <FlexGridColumn header="TypeId" binding="typeId" width="*" />
                                    <FlexGridColumn header="Multiple" binding="acceptsMultipleAnswers" width="*" />
                                    <FlexGridColumn header="Integer" binding="isInteger" width="*" />
                                </FlexGrid>
                                <Dialog open={isQuestionModalOpen} onClose={() => setIsQuestionModalOpen(false)} maxWidth="sm" fullWidth>
                                    <DialogTitle>Add/Edit Question</DialogTitle>
                                    <DialogContent dividers>
                                        <TextField
                                            label="Code"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.code || ''}
                                            onChange={(e) => setQuestionModalItem({ ...questionModalItem, code: e.target.value })}
                                            error={!!questionErrors.code}
                                            helperText={questionErrors.code}
                                        />

                                        <TextField
                                            label="Title"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.title || ''}
                                            onChange={(e) => setQuestionModalItem({ ...questionModalItem, title: e.target.value })}
                                            error={!!questionErrors.title}
                                            helperText={questionErrors.title}
                                        />

                                        <TextField
                                            label="Description"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.description || ''}
                                            onChange={(e) => setQuestionModalItem({ ...questionModalItem, description: e.target.value })}
                                            error={!!questionErrors.description}
                                            helperText={questionErrors.description}
                                        />

                                        <FormControl fullWidth margin="normal" error={!!questionErrors.typeId}>
                                            <InputLabel id="type-id-label">Question Type</InputLabel>
                                            <Select
                                                labelId="type-id-label"
                                                value={questionModalItem.typeId || ''}
                                                onChange={(e) =>
                                                    setQuestionModalItem({
                                                        ...questionModalItem,
                                                        typeId: e.target.value
                                                    })
                                                }
                                                label="Question Type"
                                            >
                                                {Array.isArray(questionTypes) &&
                                                    questionTypes.map((type) => (
                                                        <MenuItem key={type.id} value={type.id}>
                                                            {type.name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            {questionErrors.typeId && (
                                                <Typography variant="caption" color="error">
                                                    {questionErrors.typeId}
                                                </Typography>
                                            )}
                                        </FormControl>

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={questionModalItem.acceptsMultipleAnswers || false}
                                                    onChange={(e) =>
                                                        setQuestionModalItem({
                                                            ...questionModalItem,
                                                            acceptsMultipleAnswers: e.target.checked
                                                        })
                                                    }
                                                />
                                            }
                                            label="Multiple Answers"
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={questionModalItem.isInteger || false}
                                                    onChange={(e) =>
                                                        setQuestionModalItem({ ...questionModalItem, isInteger: e.target.checked })
                                                    }
                                                />
                                            }
                                            label="Integer Answer"
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={questionModalItem.hasCorrectAnswers || false}
                                                    onChange={(e) =>
                                                        setQuestionModalItem({ ...questionModalItem, hasCorrectAnswers: e.target.checked })
                                                    }
                                                />
                                            }
                                            label="Has Correct Answers"
                                        />

                                        <TextField
                                            label="Limit Low"
                                            type="number"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.limitLow ?? ''}
                                            onChange={(e) =>
                                                setQuestionModalItem({ ...questionModalItem, limitLow: parseFloat(e.target.value) })
                                            }
                                            error={!!questionErrors.limitLow}
                                            helperText={questionErrors.limitLow}
                                        />

                                        <TextField
                                            label="Limit High"
                                            type="number"
                                            fullWidth
                                            margin="normal"
                                            value={questionModalItem.limitHigh ?? ''}
                                            onChange={(e) =>
                                                setQuestionModalItem({ ...questionModalItem, limitHigh: parseFloat(e.target.value) })
                                            }
                                            error={!!questionErrors.limitHigh}
                                            helperText={questionErrors.limitHigh}
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => setIsQuestionModalOpen(false)}>Cancel</Button>
                                        <Button variant="contained" onClick={handleQuestionModalSave}>
                                            Save
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                {isQuestionChanged && (
                                    <Button variant="contained" color="primary" onClick={handleSaveQuestions}>
                                        💾 Save
                                    </Button>
                                )}
                            </>
                        }
                    />
                </div>

                <Dialog open={isConfirmOpen} onClose={() => handleConfirmResponse(false)}>
                    <DialogTitle>Confirm Save</DialogTitle>
                    <DialogContent>Are you sure you want to proceed with your current changes?</DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleConfirmResponse(false)}>No</Button>
                        <Button variant="contained" onClick={() => handleConfirmResponse(true)}>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        ),
        error: <p>error</p>
    }[(eventDataQuery.status, seasonDataQuery.status, applicationTypeProductAgesDataQuery.status)];
};

export default ChecklistScreen;
